<template>
    <div>
        <main>
            <section class="carousel-wrapper-new">
                <div class="main-img">
                    <picture class="home-banner-img">
                        <source srcset="/main_home2.avif" type="image/avif" />
                        <img src="/main_home2.png" alt="hero image" />
                    </picture>
                    <div class="container1366 section1-container">
                        <div class="section1-left">
                            <h1 class="section1-title">{{ $t("new-home1") }}</h1>
                            <h2 class="section1-subtitle">{{ $t("new-home2") }}</h2>
                            <div class="home-section2-btn-wrapper">
                                <nuxt-link :prefetch="false" :to="localePath('/register')" class="home-section1-btn1 ga4-reg-btn">{{ $t("new-home3") }}</nuxt-link>
                                <nuxt-link :prefetch="false" :to="localePath('/how-it-works')" class="home-section1-btn2">{{ $t("show-me-how") }}</nuxt-link>
                            </div>
                        </div>
                        <div class="section1-right" v-if="!mobileCheck">
                            <div class="home-section1-img" style="position: relative;">
                                <nuxt-img alt="phone image" v-if="$i18n.locale === 'it'" format="avif,webp" fit="cover" src="/main_home_phone_it.png" />
                                <nuxt-img alt="phone image" v-else-if="$i18n.locale === 'fr'" format="webp" fit="cover" src="/main_home_phone_fr.png" />
                                <nuxt-img alt="phone image" v-else-if="$i18n.locale === 'de'" format="webp" fit="cover" src="/main_home_phone_de.png" />
                                <nuxt-img alt="phone image" v-else-if="$i18n.locale === 'ru'" format="webp" fit="cover" src="/main_home_phone_ru.png" />
                                <picture v-else>
                                    <source srcset="/main_home_phone.avif" type="image/avif" />
                                    <img src="/main_home_phone.png" alt="phone image" />
                                </picture>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="home-section2">
                <div class="container1366 padding200">
                    <div class="home-left-50">
                        <div class="home-section2-img">
                            <nuxt-img alt="chart image" v-if="$i18n.locale === 'it'" format="webp" provider="static" fit="cover" src="/home_chart_it.svg" />
                            <nuxt-img alt="chart image" v-else-if="$i18n.locale === 'fr'" format="webp" provider="static" fit="cover" src="/home_chart_fr.svg" />
                            <nuxt-img alt="chart image" v-else-if="$i18n.locale === 'de'" format="webp" provider="static" fit="cover" src="/home_chart_de.svg" />
                            <nuxt-img alt="chart image" v-else-if="$i18n.locale === 'ru'" format="webp" provider="static" fit="cover" src="/home_chart_ru.svg" />
                            <nuxt-img alt="chart image" v-else format="webp" provider="static" fit="cover" src="/home_chart.svg" />
                        </div>
                    </div>
                    <div class="home-right-50">
                        <h2 class="home-section2-title home-section2-title2">{{ $t("new-home5") }}</h2>
                        <div class="home-section2-subtitle">{{ $t("new-home6") }}</div>
                        <div class="home-section2-bullets">
                            <div class="home-section2-bullet">{{ $t("new-home7") }}</div>
                            <div class="home-section2-bullet">{{ $t("new-home8") }}</div>
                            <div class="home-section2-bullet">{{ $t("new-home9") }}</div>
                            <div class="home-section2-bullet">{{ $t("new-home10") }}</div>
                        </div>
                        <div class="home-section2-btn-wrapper">
                            <nuxt-link :prefetch="false" @click.native="goSection('investment-guide')" :to="localePath('/wine-academy')" class="home-section2-btn1">{{ $t("learn-how-invest") }}</nuxt-link>
                            <nuxt-link :prefetch="false" :to="localePath('/register')" class="home-section2-btn2 ga4-reg-btn">{{ $t("new-home11") }}</nuxt-link>
                        </div>
                    </div>
                </div>
            </section>
            <section class="home-section3" v-if="mobileCheck">
                <div class="container1366 padding200">
                    <div class="home-left-50">
                        <div class="home-section3-img">
                            <nuxt-img alt="pie chart image" v-if="$i18n.locale === 'it'" format="webp" provider="static" fit="cover" src="/home_pie_chart_it.svg" />
                            <nuxt-img alt="pie chart image" v-else-if="$i18n.locale === 'fr'" format="webp" provider="static" fit="cover" src="/home_pie_chart_fr.svg" />
                            <nuxt-img alt="pie chart image" v-else-if="$i18n.locale === 'de'" format="webp" provider="static" fit="cover" src="/home_pie_chart_de.svg" />
                            <nuxt-img alt="pie chart image" v-else format="webp" provider="static" fit="cover" src="/home_pie_chart.svg" />
                        </div>
                    </div>
                    <div class="home-right-50">
                        <h2 class="home-section2-title">{{ $t("new-home12") }}</h2>
                        <div class="home-section2-subtitle">{{ $t("new-home13") }}</div>
                        <div class="home-section2-bullets">
                            <div class="home-section2-bullet">{{ $t("new-home14") }}</div>
                            <div class="home-section2-bullet">{{ $t("new-home15") }}</div>
                            <div class="home-section2-bullet">{{ $t("new-home16") }}</div>
                            <div class="home-section2-bullet">{{ $t("new-home17") }}</div>
                            <div class="home-section2-bullet">{{ $t("new-home18") }}</div>
                        </div>
                        <div class="home-section2-btn-wrapper">
                            <nuxt-link :prefetch="false" @click.native="goSection('academy-container')" :to="localePath('/wine-academy')" class="home-section2-btn1">{{ $t("learn-how-invest") }}</nuxt-link>
                        </div>
                    </div>
                </div>
            </section>
            <section class="home-section3" v-else>
                <div class="container1366 padding200">
                    <div class="home-left-50">
                        <h2 class="home-section2-title">{{ $t("new-home12") }}</h2>
                        <div class="home-section2-subtitle">{{ $t("new-home13") }}</div>
                        <div class="home-section2-bullets">
                            <div class="home-section2-bullet">{{ $t("new-home14") }}</div>
                            <div class="home-section2-bullet">{{ $t("new-home15") }}</div>
                            <div class="home-section2-bullet">{{ $t("new-home16") }}</div>
                            <div class="home-section2-bullet">{{ $t("new-home17") }}</div>
                            <div class="home-section2-bullet">{{ $t("new-home18") }}</div>
                        </div>
                        <div class="home-section2-btn-wrapper">
                            <nuxt-link :prefetch="false" @click.native="goSection('academy-container')" :to="localePath('/wine-academy')" class="home-section2-btn1">{{ $t("learn-how-invest") }}</nuxt-link>
                        </div>
                    </div>
                    <div class="home-right-50">
                        <div class="home-section3-img">
                            <nuxt-img alt="pie chart image" v-if="$i18n.locale === 'it'" format="webp" provider="static" fit="cover" src="/home_pie_chart_it.svg" />
                            <nuxt-img alt="pie chart image" v-else-if="$i18n.locale === 'fr'" format="webp" provider="static" fit="cover" src="/home_pie_chart_fr.svg" />
                            <nuxt-img alt="pie chart image" v-else-if="$i18n.locale === 'de'" format="webp" provider="static" fit="cover" src="/home_pie_chart_de.svg" />
                            <nuxt-img alt="pie chart image" v-else format="webp" provider="static" fit="cover" src="/home_pie_chart.svg" />
                        </div>
                    </div>
                </div>
            </section>
            <section class="home-section4" v-if="showBlogSection">
                <div class="container1366 padding200">
                    <v-tabs fixed-tabs class="home-tabs" v-model="selectedTab">
                        <v-tab class="horizontal-tab">{{ $t("home-title2") }}</v-tab>
                        <v-tab class="horizontal-tab">{{ $t("home-title3") }}</v-tab>
                        <v-tab class="horizontal-tab">{{ $t("home-title4") }}</v-tab>

                        <v-tab-item>
                            <div class="vtab-wrapper" v-if="mobileCheck">
                                <div class="home-left-50">
                                    <nuxt-link :prefetch="false" aria-label="wine collections page" :to="localePath('/collections')">
                                        <div class="home-section4-img"></div>
                                    </nuxt-link>
                                </div>
                                <div class="home-right-50">
                                    <i18n path="new-home19" tag="div" class="home-section4-text">
                                        <nuxt-link :prefetch="false" aria-label="wine collections page" :to="localePath('/collections')" place="tobereplaced">{{ $t('home-title2') }}</nuxt-link>
                                    </i18n>
                                    <div class="home-section2-btn-wrapper">
                                        <nuxt-link :prefetch="false" aria-label="wine collections page" :to="localePath('/collections')" class="home-section2-btn1">{{ $t("howitworks7") }}</nuxt-link>
                                    </div>
                                </div>
                            </div>
                            <div class="vtab-wrapper" v-else>
                                <div class="home-left-50">
                                    <i18n path="new-home19" tag="div" class="home-section4-text">
                                        <nuxt-link :prefetch="false" aria-label="wine collections page" :to="localePath('/collections')" place="tobereplaced">{{ $t('home-title2') }}</nuxt-link>
                                    </i18n>
                                    <div class="home-section2-btn-wrapper">
                                        <nuxt-link :prefetch="false" aria-label="wine collections page" :to="localePath('/collections')" class="home-section2-btn1">{{ $t("howitworks7") }}</nuxt-link>
                                    </div>
                                </div>
                                <div class="home-right-50">
                                    <nuxt-link :prefetch="false" aria-label="wine collections page" :to="localePath('/collections')">
                                        <div class="home-section4-img"></div>
                                    </nuxt-link>
                                </div>
                            </div>
                        </v-tab-item>
                        <v-tab-item>
                            <div class="vtab-wrapper" v-if="mobileCheck">
                                <div class="home-left-50">
                                    <nuxt-link :prefetch="false" aria-label="wine live market page" :to="localePath('/trading-desk')">
                                        <div class="home-section4-img1"></div>
                                    </nuxt-link>
                                </div>
                                <div class="home-right-50">
                                    <i18n path="new-home20" tag="div" class="home-section4-text">
                                        <nuxt-link :prefetch="false" aria-label="wine live market page" :to="localePath('/trading-desk')" place="tobereplaced">{{ $t('home-title3') }}</nuxt-link>
                                    </i18n>
                                    <div class="home-section2-btn-wrapper">
                                        <nuxt-link :prefetch="false" aria-label="wine live market page" :to="localePath('/trading-desk')" class="home-section2-btn1">{{ $t("howitworks9") }}</nuxt-link>
                                    </div>
                                </div>
                            </div>
                            <div class="vtab-wrapper" v-else>
                                <div class="home-left-50">
                                    <i18n path="new-home20" tag="div" class="home-section4-text">
                                        <nuxt-link :prefetch="false" aria-label="wine live market page" :to="localePath('/trading-desk')" place="tobereplaced">{{ $t('home-title3') }}</nuxt-link>
                                    </i18n>
                                    <div class="home-section2-btn-wrapper">
                                        <nuxt-link :prefetch="false" aria-label="wine live market page" :to="localePath('/trading-desk')" class="home-section2-btn1">{{ $t("howitworks9") }}</nuxt-link>
                                    </div>
                                </div>
                                <div class="home-right-50">
                                    <nuxt-link :prefetch="false" aria-label="wine live market page" :to="localePath('/trading-desk')">
                                        <div class="home-section4-img1"></div>
                                    </nuxt-link>
                                </div>
                            </div>
                        </v-tab-item>
                        <v-tab-item>
                            <div class="vtab-wrapper" v-if="mobileCheck">
                                <div class="home-left-50">
                                    <nuxt-link :prefetch="false" aria-label="en primeur page" :to="localePath('/en-primeur')">
                                        <div class="home-section4-img2 discover-en-primeur-btn"></div>
                                    </nuxt-link>
                                </div>
                                <div class="home-right-50">
                                    <i18n path="new-home21" tag="div" class="home-section4-text">
                                        <nuxt-link :prefetch="false" aria-label="en primeur page" :to="localePath('/en-primeur')" place="tobereplaced">{{ $t('home-title4') }}</nuxt-link>
                                    </i18n>
                                    <div class="home-section2-btn-wrapper">
                                        <nuxt-link :prefetch="false" aria-label="en primeur page" :to="localePath('/en-primeur')" class="home-section2-btn1 discover-en-primeur-btn">{{ $t("discover-enprimeur") }}</nuxt-link>
                                    </div>
                                </div>
                            </div>
                            <div class="vtab-wrapper" v-else>
                                <div class="home-left-50">
                                    <i18n path="new-home21" tag="div" class="home-section4-text">
                                        <nuxt-link :prefetch="false" aria-label="en primeur page" :to="localePath('/en-primeur')" place="tobereplaced">{{ $t('home-title4') }}</nuxt-link>
                                    </i18n>
                                    <div class="home-section2-btn-wrapper">
                                        <nuxt-link :prefetch="false" aria-label="en primeur page" :to="localePath('/en-primeur')" class="home-section2-btn1 discover-en-primeur-btn">{{ $t("discover-enprimeur") }}</nuxt-link>
                                    </div>
                                </div>
                                <div class="home-right-50">
                                    <nuxt-link :prefetch="false" aria-label="en primeur page" :to="localePath('/en-primeur')">
                                        <div class="home-section4-img2 discover-en-primeur-btn"></div>
                                    </nuxt-link>
                                </div>
                            </div>
                        </v-tab-item>
                    </v-tabs>
                </div>
            </section>
            <section class="home-section5" v-if="showBlogSection">
                <div class="home-section5-title">{{ $t("new-home22") }}</div>
                <div class="home-section9-border"></div>
                <div class="container1366 padding200">
                    <HomeTestimonials />
                </div>
            </section>
            <section class="home-section6" v-if="showBlogSection">
                <div class="home-section9-title">{{ $t("new-home24") }}</div>
                <div class="home-section9-border"></div>
                <div class="container1366 padding200">
                    <div class="home-section6-item-wrapper">
                        <div class="home-section6-item">
                            <div class="home-section6-img">
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M20 1.42856C18.9333 1.42864 17.9794 2.02787 17.1798 2.94252C16.9782 2.89681 16.7723 2.87373 16.5657 2.8737C16.5518 2.8736 16.5378 2.8736 16.5239 2.8737C15.0009 2.89692 13.7784 4.14255 13.7783 5.67123C13.7787 6.48669 14.1337 7.26137 14.7501 7.79257C14.5408 8.45121 14.3332 9.11248 14.1598 9.84808C13.2038 9.56058 12.2849 9.33345 11.4172 9.1689C9.68524 8.84048 8.15093 8.75761 6.87682 8.97442C5.60271 9.19123 4.53789 9.73642 3.97613 10.7128V10.7158C3.41453 11.6922 3.47548 12.8899 3.92545 14.1057C4.37543 15.3215 5.21173 16.6123 6.36108 17.9534C6.93729 18.6258 7.59282 19.3122 8.31971 20C7.59282 20.6878 6.93729 21.3742 6.36108 22.0465C5.21173 23.3876 4.37543 24.6784 3.92545 25.8942C3.47548 27.1101 3.41453 28.3078 3.97613 29.2842C4.5379 30.2606 5.60271 30.8087 6.87682 31.0256C7.07246 31.0588 7.28624 31.072 7.49392 31.0914C7.89521 32.1966 8.94236 32.9319 10.1144 32.9315C11.5253 32.9306 12.7131 31.872 12.8809 30.466C13.3091 30.3578 13.7141 30.2831 14.1598 30.1489C14.3899 31.1247 14.6547 32.0374 14.9469 32.8746C15.5294 34.5442 16.2245 35.9178 17.0486 36.9168C17.8727 37.9158 18.8766 38.5713 20 38.5714C21.1233 38.5713 22.1272 37.9158 22.9513 36.9168C23.7755 35.9178 24.4705 34.5442 25.0531 32.8746C25.3452 32.0374 25.61 31.1247 25.8401 30.1489C26.7964 30.4366 27.7149 30.6664 28.5828 30.8311C30.315 31.1596 31.8458 31.2423 33.1201 31.0256C34.3945 30.8088 35.462 30.2607 36.0238 29.2842C36.5855 28.3076 36.5246 27.1072 36.0745 25.8913C35.9889 25.6601 35.8775 25.4245 35.7644 25.1881C36.0862 24.7212 36.2588 24.1671 36.2593 23.5994C36.259 22.0545 35.0112 20.8022 33.4719 20.8018C33.458 20.8017 33.4441 20.8017 33.4302 20.8018C33.1433 20.8058 32.8587 20.8543 32.5865 20.9455C32.2809 20.6283 32.0144 20.316 31.6772 19.997C32.4036 19.3099 33.0599 18.6285 33.6359 17.9564C34.7855 16.6151 35.6244 15.3217 36.0745 14.1057C36.5246 12.8897 36.5855 11.6923 36.0238 10.7158V10.7128C35.462 9.73629 34.3945 9.19118 33.1201 8.97442C31.8458 8.75766 30.315 8.84032 28.5828 9.1689C27.7149 9.33353 26.7964 9.56333 25.8401 9.85108C25.61 8.87526 25.3452 7.96277 25.0531 7.12535C24.4705 5.45549 23.7755 4.07938 22.9513 3.08015C22.1271 2.08092 21.1235 1.42865 20 1.42856ZM20 2.78992C20.6003 2.78997 21.2384 3.13917 21.9079 3.95083C22.5774 4.76248 23.2271 6.00618 23.7741 7.57415C24.0614 8.39757 24.3194 9.31801 24.5463 10.3029C23.0843 10.806 21.5703 11.4059 20 12.1609C18.4304 11.4064 16.9179 10.8026 15.4567 10.2999C15.6114 9.62936 15.7844 9.00349 15.9664 8.40294C16.1632 8.44655 16.3641 8.46862 16.5657 8.46877C18.105 8.46843 19.3527 7.21613 19.3531 5.67123C19.3518 4.87899 19.0159 4.12441 18.4289 3.59478C18.9755 3.04901 19.5017 2.78996 20 2.78992ZM7.94706 10.2311C8.85343 10.187 9.94409 10.275 11.1638 10.5063C12.0177 10.6683 12.9401 10.9085 13.9035 11.2035C13.6073 12.7242 13.3719 14.34 13.2387 16.0804C11.8017 17.068 10.5255 18.083 9.36014 19.1024C8.62328 18.4123 7.95672 17.7296 7.38958 17.0678C6.31038 15.8085 5.56093 14.6205 5.19544 13.633C4.82994 12.6454 4.84764 11.9167 5.14774 11.395C5.44792 10.8732 6.06849 10.4939 7.10339 10.3178C7.36211 10.2738 7.64494 10.2457 7.94706 10.2311ZM31.084 10.2311C31.7664 10.2005 32.376 10.2298 32.8936 10.3178C33.9287 10.4939 34.549 10.8732 34.8492 11.395C35.1494 11.9168 35.1672 12.6453 34.8015 13.633C34.4359 14.6207 33.6869 15.8084 32.6074 17.0678C32.0409 17.7288 31.3754 18.41 30.6398 19.0994C29.475 18.0804 28.1975 17.0677 26.7613 16.0804C26.6276 14.3401 26.3931 12.7241 26.0965 11.2035C27.0589 10.9086 27.9799 10.6682 28.8332 10.5063C29.6465 10.3521 30.4016 10.2616 31.084 10.2311ZM15.2003 11.6553C16.2504 12.0233 17.332 12.4598 18.4527 12.9658C17.8156 13.3 17.181 13.6139 16.5388 13.986C15.8966 14.3582 15.3095 14.7541 14.7024 15.141C14.8263 13.9128 14.9926 12.7529 15.2003 11.6553ZM24.7997 11.6553C25.0068 12.752 25.174 13.9109 25.2975 15.138C24.6898 14.7507 24.1012 14.3556 23.4581 13.983C22.817 13.6116 22.1833 13.2994 21.5472 12.9658C22.6677 12.4597 23.7498 12.0235 24.7997 11.6553ZM20 13.6809C20.9193 14.1378 21.8479 14.621 22.7814 15.1619C23.7154 15.703 24.5984 16.2666 25.4525 16.8374C25.5179 17.8665 25.5629 18.9163 25.5629 20C25.5628 21.0835 25.5179 22.1335 25.4525 23.1625C24.5984 23.7333 23.7154 24.297 22.7814 24.8381C21.8479 25.379 20.9193 25.8622 20 26.3191C19.0795 25.8615 18.1503 25.3768 17.2155 24.8351C16.2818 24.294 15.3986 23.7301 14.5444 23.1596C14.4789 22.1314 14.4341 21.0825 14.4341 20C14.4341 18.9173 14.4789 17.8686 14.5444 16.8404C15.3986 16.2698 16.2818 15.706 17.2155 15.1649C18.1503 14.6232 19.0795 14.1385 20 13.6809ZM19.8688 16.0005C17.7024 16.0005 15.9314 17.7778 15.9314 19.9521C15.9314 22.1264 17.7024 23.9038 19.8688 23.9038C22.0352 23.9038 23.8061 22.1264 23.8061 19.9521C23.8061 17.7778 22.0352 16.0005 19.8688 16.0005ZM13.1582 17.8248C13.128 18.5464 13.0806 19.255 13.0807 20C13.0807 20.7449 13.1279 21.4536 13.1582 22.1752C12.1597 21.4534 11.2414 20.7294 10.3976 20C11.2414 19.2706 12.1597 18.5466 13.1582 17.8248H13.1582ZM26.8418 17.8248C27.8392 18.5464 28.7564 19.2708 29.5994 20C28.7564 20.7291 27.8392 21.4536 26.8418 22.1752C26.8721 21.4536 26.9193 20.7449 26.9193 20C26.9193 19.255 26.872 18.5464 26.8418 17.8248ZM9.36014 20.8976C10.5255 21.917 11.8017 22.932 13.2387 23.9195C13.3723 25.6599 13.6069 27.2758 13.9035 28.7965C13.4981 28.9206 13.1057 29.0286 12.7169 29.1316C12.3033 28.0503 11.2685 27.3365 10.1144 27.3364C10.0995 27.3363 10.0846 27.3363 10.0697 27.3364C8.7098 27.3573 7.56343 28.36 7.35679 29.7091C7.275 29.6985 7.18113 29.6954 7.10339 29.6821C6.06849 29.506 5.44792 29.1267 5.14774 28.605C4.84764 28.0832 4.82994 27.3545 5.19544 26.367C5.56093 25.3794 6.31038 24.1914 7.38958 22.9322C7.95672 22.2704 8.62328 21.5877 9.36014 20.8976ZM30.6368 20.8976C30.9189 21.1619 31.1818 21.4232 31.4417 21.6845C30.9559 22.2029 30.6851 22.8877 30.6845 23.5994C30.6849 25.1443 31.9326 26.3966 33.4719 26.3969C33.8933 26.3966 34.3092 26.3005 34.6882 26.1157C34.723 26.1984 34.7718 26.2868 34.8015 26.367C35.1672 27.3547 35.1494 28.0832 34.8492 28.605C34.549 29.1268 33.9287 29.5061 32.8936 29.6821C31.8585 29.8582 30.4597 29.8022 28.8332 29.4936C27.9799 29.3318 27.0589 29.0914 26.0965 28.7965C26.3932 27.2749 26.6276 25.6581 26.7613 23.9165C28.1968 22.9302 29.4725 21.9156 30.6368 20.8976H30.6368ZM14.7024 24.859C15.3095 25.2458 15.8966 25.6418 16.5388 26.0139C17.181 26.3861 17.8156 26.7 18.4527 27.0342C17.332 27.5401 16.2504 27.9766 15.2003 28.3447C14.9926 27.247 14.8263 26.0872 14.7024 24.859ZM25.2975 24.859C25.174 26.0873 25.007 27.247 24.7997 28.3447C23.749 27.9762 22.6656 27.5408 21.5442 27.0342C22.1815 26.6999 22.8158 26.3861 23.4581 26.0139C24.1012 25.6414 24.6898 25.2462 25.2975 24.859ZM19.994 27.8361C21.5665 28.5924 23.0823 29.1934 24.5463 29.6971C24.3194 30.682 24.0614 31.6026 23.7741 32.4258C23.2271 33.9935 22.5773 35.2377 21.9079 36.0491C21.2385 36.8606 20.6003 37.21 20 37.21C19.3997 37.21 18.7614 36.8606 18.092 36.0491C17.4226 35.2377 16.7728 33.9935 16.2258 32.4258C15.9385 31.6026 15.6808 30.682 15.4537 29.6971C16.9141 29.1943 18.4253 28.5904 19.994 27.8361Z" fill="#907D4C"/>
                                </svg>
                            </div>
                            <div class="home-section6-title">{{ $t("new-home25") }}</div>
                            <div class="home-section6-subtitle">{{ $t("new-home26") }}</div>
                        </div>
                        <div class="home-section6-item">
                            <div class="home-section6-img">
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17.0107 3.66182C16.5098 3.39587 15.8991 3.74877 15.8991 4.30416V6.10586C9.62498 7.72132 5 13.2851 5 19.9003C5 26.0262 8.96544 31.2477 14.5301 33.2705L15.319 31.2142C10.6072 29.5014 7.25498 25.0805 7.25498 19.9003C7.25498 14.508 10.8867 9.94144 15.8991 8.3918V10.6193C15.8991 11.1746 16.5098 11.5275 17.0107 11.2616L22.9576 8.10405C23.4799 7.82673 23.4799 7.09668 22.9576 6.81936L17.0107 3.66182Z" fill="#907D4C"/>
                                    <path d="M22.9893 36.3382C23.4902 36.6042 24.1009 36.2513 24.1009 35.6959V33.8942C30.375 32.2787 35 26.715 35 20.0997C35 13.9739 31.0346 8.75234 25.4699 6.7295L24.681 8.78584C29.3928 10.4987 32.745 14.9195 32.745 20.0997C32.745 25.492 29.1133 30.0586 24.1009 31.6082V29.3808C24.1009 28.8254 23.4902 28.4725 22.9893 28.7384L17.0424 31.896C16.5201 32.1733 16.5201 32.9033 17.0424 33.1807L22.9893 36.3382Z" fill="#907D4C"/>
                                    <path d="M21.3714 27.381V25.5619C23.0286 25.2476 24.3333 24.2953 24.3429 22.5524C24.3429 20.1524 22.2857 19.3238 20.3619 18.8286C18.4381 18.3333 17.819 17.8095 17.819 17.0095C17.819 16.0953 18.6762 15.4476 20.1048 15.4476C21.6095 15.4476 22.1714 16.1714 22.219 17.2286H24.0857C24.0286 15.7714 23.1429 14.4286 21.3714 14V12.1429H18.8286V13.981C17.1905 14.3333 15.8667 15.4 15.8667 17.0381C15.8667 18.9905 17.4857 19.9619 19.8476 20.5333C21.9714 21.0381 22.3905 21.781 22.3905 22.5714C22.3905 23.1524 21.9714 24.0857 20.1048 24.0857C18.3619 24.0857 17.6762 23.3048 17.581 22.3048H15.7143C15.819 24.1524 17.2 25.2 18.8286 25.5429V27.381H21.3714Z" fill="#907D4C"/>
                                </svg>
                            </div>
                            <div class="home-section6-title">{{ $t("new-home27") }}</div>
                            <div class="home-section6-subtitle">{{ $t("new-home28") }}</div>
                        </div>
                        <div class="home-section6-item">
                            <div class="home-section6-img">
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M30.9244 1.44544L14.1177 1.42856C12.2689 1.42856 10.7563 2.94804 10.7563 4.80518V9.87012H14.1177V5.32466H30.9244V34.6753H14.1177V30.1299H10.7563V35.1948C10.7563 37.0519 12.2689 38.5714 14.1177 38.5714H30.9244C32.7731 38.5714 34.2857 37.0519 34.2857 35.1948V4.80518C34.2857 2.94804 32.7731 1.44544 30.9244 1.44544ZM17.479 25.0649H20.8403V13.2467H9.07564V16.6234H15.1093L5.71429 26.061L8.08404 28.4415L17.479 19.0039V25.0649Z" fill="#907D4C"/>
                                </svg>
                            </div>
                            <div class="home-section6-title">{{ $t("new-home29") }}</div>
                            <div class="home-section6-subtitle">{{ $t("new-home30") }}</div>
                        </div>
                    </div>
                    <div class="home-section6-item-wrapper">
                        <div class="home-section6-item">
                            <div class="home-section6-img">
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.1429 3.57143H7.85714V6.42857H12.1429V3.57143Z" fill="#907D4C"/>
                                    <path d="M12.1429 7.85714H7.85714V12.2654C7.85714 12.6443 7.70663 13.0077 7.43872 13.2756L6.55112 14.1632C6.0153 14.699 5.71428 15.4257 5.71428 16.1835V35C5.71428 35.789 6.35387 36.4286 7.14285 36.4286H12.8571C13.6461 36.4286 14.2857 35.789 14.2857 35V16.1835C14.2857 15.4257 13.9847 14.699 13.4489 14.1632L12.5613 13.2756C12.2934 13.0077 12.1429 12.6443 12.1429 12.2654V7.85714Z" fill="#907D4C"/>
                                    <path d="M22.1429 3.57143H17.8571V6.42857H22.1429V3.57143Z" fill="#907D4C"/>
                                    <path d="M22.1429 7.85714H17.8571V12.2654C17.8571 12.6443 17.7066 13.0077 17.4387 13.2756L16.5511 14.1632C16.0153 14.699 15.7143 15.4257 15.7143 16.1835V35C15.7143 35.789 16.3539 36.4286 17.1429 36.4286H22.8571C23.6461 36.4286 24.2857 35.789 24.2857 35V16.1835C24.2857 15.4257 23.9847 14.699 23.4489 14.1632L22.5613 13.2756C22.2934 13.0077 22.1429 12.6443 22.1429 12.2654V7.85714Z" fill="#907D4C"/>
                                    <path d="M32.1429 3.57143H27.8571V6.42857H32.1429V3.57143Z" fill="#907D4C"/>
                                    <path d="M32.1429 7.85714H27.8571V12.2654C27.8571 12.6443 27.7066 13.0077 27.4387 13.2756L26.5511 14.1632C26.0153 14.699 25.7143 15.4257 25.7143 16.1835V35C25.7143 35.789 26.3539 36.4286 27.1429 36.4286H32.8571C33.6461 36.4286 34.2857 35.789 34.2857 35V16.1835C34.2857 15.4257 33.9847 14.699 33.4489 14.1632L32.5613 13.2756C32.2934 13.0077 32.1429 12.6443 32.1429 12.2654V7.85714Z" fill="#907D4C"/>
                                </svg>
                            </div>
                            <div class="home-section6-title">{{ $t("new-home31") }}</div>
                            <div class="home-section6-subtitle">{{ $t("new-home32") }}</div>
                        </div>
                        <div class="home-section6-item">
                            <div class="home-section6-img">
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M33.1429 3.57143H6.85714C5.05 3.57143 3.57143 5.05 3.57143 6.85714V33.1429C3.57143 34.95 5.05 36.4286 6.85714 36.4286H33.1429C34.95 36.4286 36.4286 34.95 36.4286 33.1429V6.85714C36.4286 5.05 34.95 3.57143 33.1429 3.57143ZM33.1429 33.1429H6.85714V6.85714H33.1429V33.1429ZM29.8571 10.1429H21.6429C19.8357 10.1429 18.3571 11.6214 18.3571 13.4286V17.1743C17.3714 17.7493 16.7143 18.7843 16.7143 20C16.7143 21.8071 18.1929 23.2857 20 23.2857C21.8071 23.2857 23.2857 21.8071 23.2857 20C23.2857 18.7843 22.6286 17.7329 21.6429 17.1743V13.4286H26.5714V26.5714H13.4286V13.4286H16.7143V10.1429H10.1429V29.8571H29.8571V10.1429Z" fill="#907D4C"/>
                                </svg>
                            </div>
                            <div class="home-section6-title">{{ $t("new-home33") }}</div>
                            <div class="home-section6-subtitle">{{ $t("new-home34") }}</div>
                        </div>
                        <div class="home-section6-item">
                            <div class="home-section6-img">
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19.4106 3.57153C12.753 3.83319 6.85742 8.01678 4.56476 14.3306C2.19711 20.8506 4.15423 28.1617 9.4571 32.6216C14.5926 36.9409 21.786 37.6104 27.6825 34.4996L19.4106 20.1469V3.57153ZM21.3338 3.61241V18.6852H36.3716C35.73 10.6214 29.3789 4.25574 21.3338 3.61241ZM23.5192 6.20107C28.5688 7.47877 32.5143 11.4334 33.7889 16.4947H23.5192V6.20107ZM21.8935 20.6104L29.3308 33.5153C33.605 30.5666 36.226 25.8078 36.4287 20.6104H21.8935Z" fill="#907D4C"/>
                                </svg>
                            </div>
                            <div class="home-section6-title">{{ $t("new-home35") }}</div>
                            <div class="home-section6-subtitle">{{ $t("new-home36") }}</div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="home-section7" v-if="showBlogSection">
                <h2 class="home-section9-title">{{ $t("new-home37") }}</h2>
                <div class="home-section9-border"></div>
                <div class="container1366 padding200">
                    <div class="journey-item journey-item1">
                        <div class="journey-num-border">
                            <div class="journey-num">1</div>
                        </div>
                        <div class="journey-title">{{ $t("new-home38") }}</div>
                    </div>
                    <div class="journey-separator journey-separator1"></div>
                    <div class="journey-item journey-item2">
                        <div class="journey-num-border">
                            <div class="journey-num">2</div>
                        </div>
                        <div class="journey-title">{{ $t("new-home39") }}</div>
                    </div>
                    <div class="journey-separator journey-separator2"></div>
                    <div class="journey-item journey-item3">
                        <div class="journey-num-border">
                            <div class="journey-num">3</div>
                        </div>
                        <div class="journey-title">{{ $t("new-home40") }}</div>
                    </div>
                    <div class="journey-separator journey-separator3"></div>
                    <div class="journey-item journey-item4">
                        <div class="journey-num-border">
                            <div class="journey-num">4</div>
                        </div>
                        <div class="journey-title">{{ $t("new-home41") }}</div>
                    </div>

                    <div class="home-section2-btn-wrapper center">
                        <nuxt-link :prefetch="false" :to="localePath('/register')" class="home-section2-btn1 ga4-reg-btn">{{ $t("new-home42") }}</nuxt-link>
                        <nuxt-link :prefetch="false" :to="localePath('/how-it-works')" class="home-section2-btn2">{{ $t("learn-more-investing") }}</nuxt-link>
                    </div>
                </div>
            </section>
            <section class="home-section8" v-if="showBlogSection">
                <div class="home-section8-title">{{ $t("new-home43") }}</div>
                <div class="home-section9-border"></div>
                <div class="container1366 padding200">
                    <HomeWineSlider />
                </div>
            </section>
            <section class="home-section9 news-section9" v-if="showBlogSection">
                <div class="home-section9-title">{{ $t("new-home45") }}</div>
                <div class="home-section9-border"></div>
                <div class="news-wrapper">
                    <div class="container1366 padding200">
                        <vueper-slides class="no-shadow news-articles-carousel"
                                       :touchable="false"
                                       :gap="0"
                                       :visible-slides="mobileCheck ? 1 : 1.3"
                                       :fixed-height="mobileCheck ? '450px' : '420px'">
                            <vueper-slide v-for="(slide, i) in blogPosts" :key="i">
                                <template #content>
                                    <div class="vueperslide__content-wrapper blog-img-layer">
                                        <div class="slide-bg" :style="getImgUrl(slide.img)"></div>
                                        <div class="news-carousel-text-wrapper">
                                            <div class="news__title">{{ slide.title }}</div>
                                            <div class="news__content">{{ slide.subtitle }}</div>
                                            <div style="z-index: 100">
                                                <a :href="slide.link" target="_blank" class="news__button">{{ $t("wine-academy49") }}</a>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </vueper-slide>
                        </vueper-slides>
                    </div>
                </div>
            </section>
            <section class="home-section10" v-if="showBlogSection">
                <div class="container1366 padding200">
                    <h2 class="home-section10-title">{{ $t("new-home46") }}</h2>
                    <div class="home-section10-subtitle">{{ $t("new-home47") }}</div>
                    <div class="home-section10-btn-wrapper center">
                        <div v-on:click="bookChat2 = true" class="home-section2-btn1 btn-white">{{ $t("new-home48") }}</div>
                        <nuxt-link :prefetch="false" :to="localePath(isLogged ? '/trading-desk' : '/register')" class="home-section2-btn2 border-white ga4-reg-btn">{{ $t("new-home3") }}</nuxt-link>
                    </div>

                    <div class="home-section10-left">
                        <div class="home-section10-title2">{{ $t("new-home49") }}</div>
                        <div class="home-section10-qr-wrapper">
                            <svg width="132" height="132" viewBox="0 0 132 132" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_401_3452)">
                                    <path d="M132 0H0V132H132V0Z" fill="white"/>
                                    <path d="M14.52 11.22H11.22V14.52H14.52V11.22Z" fill="black"/>
                                    <path d="M17.82 11.22H14.52V14.52H17.82V11.22Z" fill="black"/>
                                    <path d="M21.12 11.22H17.82V14.52H21.12V11.22Z" fill="black"/>
                                    <path d="M24.42 11.22H21.12V14.52H24.42V11.22Z" fill="black"/>
                                    <path d="M27.72 11.22H24.42V14.52H27.72V11.22Z" fill="black"/>
                                    <path d="M31.02 11.22H27.72V14.52H31.02V11.22Z" fill="black"/>
                                    <path d="M34.32 11.22H31.02V14.52H34.32V11.22Z" fill="black"/>
                                    <path d="M44.22 11.22H40.92V14.52H44.22V11.22Z" fill="black"/>
                                    <path d="M47.52 11.22H44.22V14.52H47.52V11.22Z" fill="black"/>
                                    <path d="M50.82 11.22H47.52V14.52H50.82V11.22Z" fill="black"/>
                                    <path d="M60.72 11.22H57.42V14.52H60.72V11.22Z" fill="black"/>
                                    <path d="M73.92 11.22H70.62V14.52H73.92V11.22Z" fill="black"/>
                                    <path d="M83.82 11.22H80.52V14.52H83.82V11.22Z" fill="black"/>
                                    <path d="M100.32 11.22H97.02V14.52H100.32V11.22Z" fill="black"/>
                                    <path d="M103.62 11.22H100.32V14.52H103.62V11.22Z" fill="black"/>
                                    <path d="M106.92 11.22H103.62V14.52H106.92V11.22Z" fill="black"/>
                                    <path d="M110.22 11.22H106.92V14.52H110.22V11.22Z" fill="black"/>
                                    <path d="M113.52 11.22H110.22V14.52H113.52V11.22Z" fill="black"/>
                                    <path d="M116.82 11.22H113.52V14.52H116.82V11.22Z" fill="black"/>
                                    <path d="M120.12 11.22H116.82V14.52H120.12V11.22Z" fill="black"/>
                                    <path d="M14.52 14.52H11.22V17.82H14.52V14.52Z" fill="black"/>
                                    <path d="M34.32 14.52H31.02V17.82H34.32V14.52Z" fill="black"/>
                                    <path d="M50.82 14.52H47.52V17.82H50.82V14.52Z" fill="black"/>
                                    <path d="M54.12 14.52H50.82V17.82H54.12V14.52Z" fill="black"/>
                                    <path d="M67.32 14.52H64.02V17.82H67.32V14.52Z" fill="black"/>
                                    <path d="M73.92 14.52H70.62V17.82H73.92V14.52Z" fill="black"/>
                                    <path d="M80.52 14.52H77.22V17.82H80.52V14.52Z" fill="black"/>
                                    <path d="M83.82 14.52H80.52V17.82H83.82V14.52Z" fill="black"/>
                                    <path d="M100.32 14.52H97.02V17.82H100.32V14.52Z" fill="black"/>
                                    <path d="M120.12 14.52H116.82V17.82H120.12V14.52Z" fill="black"/>
                                    <path d="M14.52 17.8201H11.22V21.1201H14.52V17.8201Z" fill="black"/>
                                    <path d="M21.12 17.8201H17.82V21.1201H21.12V17.8201Z" fill="black"/>
                                    <path d="M24.42 17.8201H21.12V21.1201H24.42V17.8201Z" fill="black"/>
                                    <path d="M27.72 17.8201H24.42V21.1201H27.72V17.8201Z" fill="black"/>
                                    <path d="M34.32 17.8201H31.02V21.1201H34.32V17.8201Z" fill="black"/>
                                    <path d="M44.22 17.8201H40.92V21.1201H44.22V17.8201Z" fill="black"/>
                                    <path d="M47.52 17.8201H44.22V21.1201H47.52V17.8201Z" fill="black"/>
                                    <path d="M50.82 17.8201H47.52V21.1201H50.82V17.8201Z" fill="black"/>
                                    <path d="M60.72 17.8201H57.42V21.1201H60.72V17.8201Z" fill="black"/>
                                    <path d="M67.32 17.8201H64.02V21.1201H67.32V17.8201Z" fill="black"/>
                                    <path d="M77.22 17.8201H73.92V21.1201H77.22V17.8201Z" fill="black"/>
                                    <path d="M80.52 17.8201H77.22V21.1201H80.52V17.8201Z" fill="black"/>
                                    <path d="M83.82 17.8201H80.52V21.1201H83.82V17.8201Z" fill="black"/>
                                    <path d="M90.42 17.8201H87.12V21.1201H90.42V17.8201Z" fill="black"/>
                                    <path d="M100.32 17.8201H97.02V21.1201H100.32V17.8201Z" fill="black"/>
                                    <path d="M106.92 17.8201H103.62V21.1201H106.92V17.8201Z" fill="black"/>
                                    <path d="M110.22 17.8201H106.92V21.1201H110.22V17.8201Z" fill="black"/>
                                    <path d="M113.52 17.8201H110.22V21.1201H113.52V17.8201Z" fill="black"/>
                                    <path d="M120.12 17.8201H116.82V21.1201H120.12V17.8201Z" fill="black"/>
                                    <path d="M14.52 21.1201H11.22V24.4201H14.52V21.1201Z" fill="black"/>
                                    <path d="M21.12 21.1201H17.82V24.4201H21.12V21.1201Z" fill="black"/>
                                    <path d="M24.42 21.1201H21.12V24.4201H24.42V21.1201Z" fill="black"/>
                                    <path d="M27.72 21.1201H24.42V24.4201H27.72V21.1201Z" fill="black"/>
                                    <path d="M34.32 21.1201H31.02V24.4201H34.32V21.1201Z" fill="black"/>
                                    <path d="M40.92 21.1201H37.62V24.4201H40.92V21.1201Z" fill="black"/>
                                    <path d="M47.52 21.1201H44.22V24.4201H47.52V21.1201Z" fill="black"/>
                                    <path d="M50.82 21.1201H47.52V24.4201H50.82V21.1201Z" fill="black"/>
                                    <path d="M57.42 21.1201H54.12V24.4201H57.42V21.1201Z" fill="black"/>
                                    <path d="M70.62 21.1201H67.32V24.4201H70.62V21.1201Z" fill="black"/>
                                    <path d="M77.22 21.1201H73.92V24.4201H77.22V21.1201Z" fill="black"/>
                                    <path d="M83.82 21.1201H80.52V24.4201H83.82V21.1201Z" fill="black"/>
                                    <path d="M90.42 21.1201H87.12V24.4201H90.42V21.1201Z" fill="black"/>
                                    <path d="M93.72 21.1201H90.42V24.4201H93.72V21.1201Z" fill="black"/>
                                    <path d="M100.32 21.1201H97.02V24.4201H100.32V21.1201Z" fill="black"/>
                                    <path d="M106.92 21.1201H103.62V24.4201H106.92V21.1201Z" fill="black"/>
                                    <path d="M110.22 21.1201H106.92V24.4201H110.22V21.1201Z" fill="black"/>
                                    <path d="M113.52 21.1201H110.22V24.4201H113.52V21.1201Z" fill="black"/>
                                    <path d="M120.12 21.1201H116.82V24.4201H120.12V21.1201Z" fill="black"/>
                                    <path d="M14.52 24.4199H11.22V27.7199H14.52V24.4199Z" fill="black"/>
                                    <path d="M21.12 24.4199H17.82V27.7199H21.12V24.4199Z" fill="black"/>
                                    <path d="M24.42 24.4199H21.12V27.7199H24.42V24.4199Z" fill="black"/>
                                    <path d="M27.72 24.4199H24.42V27.7199H27.72V24.4199Z" fill="black"/>
                                    <path d="M34.32 24.4199H31.02V27.7199H34.32V24.4199Z" fill="black"/>
                                    <path d="M40.92 24.4199H37.62V27.7199H40.92V24.4199Z" fill="black"/>
                                    <path d="M47.52 24.4199H44.22V27.7199H47.52V24.4199Z" fill="black"/>
                                    <path d="M54.12 24.4199H50.82V27.7199H54.12V24.4199Z" fill="black"/>
                                    <path d="M57.42 24.4199H54.12V27.7199H57.42V24.4199Z" fill="black"/>
                                    <path d="M67.32 24.4199H64.02V27.7199H67.32V24.4199Z" fill="black"/>
                                    <path d="M73.92 24.4199H70.62V27.7199H73.92V24.4199Z" fill="black"/>
                                    <path d="M77.22 24.4199H73.92V27.7199H77.22V24.4199Z" fill="black"/>
                                    <path d="M83.82 24.4199H80.52V27.7199H83.82V24.4199Z" fill="black"/>
                                    <path d="M90.42 24.4199H87.12V27.7199H90.42V24.4199Z" fill="black"/>
                                    <path d="M100.32 24.4199H97.02V27.7199H100.32V24.4199Z" fill="black"/>
                                    <path d="M106.92 24.4199H103.62V27.7199H106.92V24.4199Z" fill="black"/>
                                    <path d="M110.22 24.4199H106.92V27.7199H110.22V24.4199Z" fill="black"/>
                                    <path d="M113.52 24.4199H110.22V27.7199H113.52V24.4199Z" fill="black"/>
                                    <path d="M120.12 24.4199H116.82V27.7199H120.12V24.4199Z" fill="black"/>
                                    <path d="M14.52 27.72H11.22V31.02H14.52V27.72Z" fill="black"/>
                                    <path d="M34.32 27.72H31.02V31.02H34.32V27.72Z" fill="black"/>
                                    <path d="M44.22 27.72H40.92V31.02H44.22V27.72Z" fill="black"/>
                                    <path d="M47.52 27.72H44.22V31.02H47.52V27.72Z" fill="black"/>
                                    <path d="M57.42 27.72H54.12V31.02H57.42V27.72Z" fill="black"/>
                                    <path d="M60.72 27.72H57.42V31.02H60.72V27.72Z" fill="black"/>
                                    <path d="M80.52 27.72H77.22V31.02H80.52V27.72Z" fill="black"/>
                                    <path d="M87.12 27.72H83.82V31.02H87.12V27.72Z" fill="black"/>
                                    <path d="M93.72 27.72H90.42V31.02H93.72V27.72Z" fill="black"/>
                                    <path d="M100.32 27.72H97.02V31.02H100.32V27.72Z" fill="black"/>
                                    <path d="M120.12 27.72H116.82V31.02H120.12V27.72Z" fill="black"/>
                                    <path d="M14.52 31.02H11.22V34.32H14.52V31.02Z" fill="black"/>
                                    <path d="M17.82 31.02H14.52V34.32H17.82V31.02Z" fill="black"/>
                                    <path d="M21.12 31.02H17.82V34.32H21.12V31.02Z" fill="black"/>
                                    <path d="M24.42 31.02H21.12V34.32H24.42V31.02Z" fill="black"/>
                                    <path d="M27.72 31.02H24.42V34.32H27.72V31.02Z" fill="black"/>
                                    <path d="M31.02 31.02H27.72V34.32H31.02V31.02Z" fill="black"/>
                                    <path d="M34.32 31.02H31.02V34.32H34.32V31.02Z" fill="black"/>
                                    <path d="M40.92 31.02H37.62V34.32H40.92V31.02Z" fill="black"/>
                                    <path d="M47.52 31.02H44.22V34.32H47.52V31.02Z" fill="black"/>
                                    <path d="M54.12 31.02H50.82V34.32H54.12V31.02Z" fill="black"/>
                                    <path d="M60.72 31.02H57.42V34.32H60.72V31.02Z" fill="black"/>
                                    <path d="M67.32 31.02H64.02V34.32H67.32V31.02Z" fill="black"/>
                                    <path d="M73.92 31.02H70.62V34.32H73.92V31.02Z" fill="black"/>
                                    <path d="M80.52 31.02H77.22V34.32H80.52V31.02Z" fill="black"/>
                                    <path d="M87.12 31.02H83.82V34.32H87.12V31.02Z" fill="black"/>
                                    <path d="M93.72 31.02H90.42V34.32H93.72V31.02Z" fill="black"/>
                                    <path d="M100.32 31.02H97.02V34.32H100.32V31.02Z" fill="black"/>
                                    <path d="M103.62 31.02H100.32V34.32H103.62V31.02Z" fill="black"/>
                                    <path d="M106.92 31.02H103.62V34.32H106.92V31.02Z" fill="black"/>
                                    <path d="M110.22 31.02H106.92V34.32H110.22V31.02Z" fill="black"/>
                                    <path d="M113.52 31.02H110.22V34.32H113.52V31.02Z" fill="black"/>
                                    <path d="M116.82 31.02H113.52V34.32H116.82V31.02Z" fill="black"/>
                                    <path d="M120.12 31.02H116.82V34.32H120.12V31.02Z" fill="black"/>
                                    <path d="M44.22 34.3201H40.92V37.6201H44.22V34.3201Z" fill="black"/>
                                    <path d="M54.12 34.3201H50.82V37.6201H54.12V34.3201Z" fill="black"/>
                                    <path d="M64.02 34.3201H60.72V37.6201H64.02V34.3201Z" fill="black"/>
                                    <path d="M67.32 34.3201H64.02V37.6201H67.32V34.3201Z" fill="black"/>
                                    <path d="M73.92 34.3201H70.62V37.6201H73.92V34.3201Z" fill="black"/>
                                    <path d="M77.22 34.3201H73.92V37.6201H77.22V34.3201Z" fill="black"/>
                                    <path d="M87.12 34.3201H83.82V37.6201H87.12V34.3201Z" fill="black"/>
                                    <path d="M14.52 37.6201H11.22V40.9201H14.52V37.6201Z" fill="black"/>
                                    <path d="M17.82 37.6201H14.52V40.9201H17.82V37.6201Z" fill="black"/>
                                    <path d="M31.02 37.6201H27.72V40.9201H31.02V37.6201Z" fill="black"/>
                                    <path d="M34.32 37.6201H31.02V40.9201H34.32V37.6201Z" fill="black"/>
                                    <path d="M37.62 37.6201H34.32V40.9201H37.62V37.6201Z" fill="black"/>
                                    <path d="M44.22 37.6201H40.92V40.9201H44.22V37.6201Z" fill="black"/>
                                    <path d="M47.52 37.6201H44.22V40.9201H47.52V37.6201Z" fill="black"/>
                                    <path d="M54.12 37.6201H50.82V40.9201H54.12V37.6201Z" fill="black"/>
                                    <path d="M57.42 37.6201H54.12V40.9201H57.42V37.6201Z" fill="black"/>
                                    <path d="M60.72 37.6201H57.42V40.9201H60.72V37.6201Z" fill="black"/>
                                    <path d="M70.62 37.6201H67.32V40.9201H70.62V37.6201Z" fill="black"/>
                                    <path d="M73.92 37.6201H70.62V40.9201H73.92V37.6201Z" fill="black"/>
                                    <path d="M80.52 37.6201H77.22V40.9201H80.52V37.6201Z" fill="black"/>
                                    <path d="M106.92 37.6201H103.62V40.9201H106.92V37.6201Z" fill="black"/>
                                    <path d="M110.22 37.6201H106.92V40.9201H110.22V37.6201Z" fill="black"/>
                                    <path d="M14.52 40.9199H11.22V44.2199H14.52V40.9199Z" fill="black"/>
                                    <path d="M17.82 40.9199H14.52V44.2199H17.82V40.9199Z" fill="black"/>
                                    <path d="M21.12 40.9199H17.82V44.2199H21.12V40.9199Z" fill="black"/>
                                    <path d="M24.42 40.9199H21.12V44.2199H24.42V40.9199Z" fill="black"/>
                                    <path d="M27.72 40.9199H24.42V44.2199H27.72V40.9199Z" fill="black"/>
                                    <path d="M40.92 40.9199H37.62V44.2199H40.92V40.9199Z" fill="black"/>
                                    <path d="M47.52 40.9199H44.22V44.2199H47.52V40.9199Z" fill="black"/>
                                    <path d="M60.72 40.9199H57.42V44.2199H60.72V40.9199Z" fill="black"/>
                                    <path d="M64.02 40.9199H60.72V44.2199H64.02V40.9199Z" fill="black"/>
                                    <path d="M67.32 40.9199H64.02V44.2199H67.32V40.9199Z" fill="black"/>
                                    <path d="M70.62 40.9199H67.32V44.2199H70.62V40.9199Z" fill="black"/>
                                    <path d="M77.22 40.9199H73.92V44.2199H77.22V40.9199Z" fill="black"/>
                                    <path d="M83.82 40.9199H80.52V44.2199H83.82V40.9199Z" fill="black"/>
                                    <path d="M87.12 40.9199H83.82V44.2199H87.12V40.9199Z" fill="black"/>
                                    <path d="M90.42 40.9199H87.12V44.2199H90.42V40.9199Z" fill="black"/>
                                    <path d="M103.62 40.9199H100.32V44.2199H103.62V40.9199Z" fill="black"/>
                                    <path d="M106.92 40.9199H103.62V44.2199H106.92V40.9199Z" fill="black"/>
                                    <path d="M113.52 40.9199H110.22V44.2199H113.52V40.9199Z" fill="black"/>
                                    <path d="M116.82 40.9199H113.52V44.2199H116.82V40.9199Z" fill="black"/>
                                    <path d="M14.52 44.22H11.22V47.52H14.52V44.22Z" fill="black"/>
                                    <path d="M17.82 44.22H14.52V47.52H17.82V44.22Z" fill="black"/>
                                    <path d="M31.02 44.22H27.72V47.52H31.02V44.22Z" fill="black"/>
                                    <path d="M34.32 44.22H31.02V47.52H34.32V44.22Z" fill="black"/>
                                    <path d="M37.62 44.22H34.32V47.52H37.62V44.22Z" fill="black"/>
                                    <path d="M40.92 44.22H37.62V47.52H40.92V44.22Z" fill="black"/>
                                    <path d="M44.22 44.22H40.92V47.52H44.22V44.22Z" fill="black"/>
                                    <path d="M50.82 44.22H47.52V47.52H50.82V44.22Z" fill="black"/>
                                    <path d="M54.12 44.22H50.82V47.52H54.12V44.22Z" fill="black"/>
                                    <path d="M60.72 44.22H57.42V47.52H60.72V44.22Z" fill="black"/>
                                    <path d="M64.02 44.22H60.72V47.52H64.02V44.22Z" fill="black"/>
                                    <path d="M67.32 44.22H64.02V47.52H67.32V44.22Z" fill="black"/>
                                    <path d="M87.12 44.22H83.82V47.52H87.12V44.22Z" fill="black"/>
                                    <path d="M97.02 44.22H93.72V47.52H97.02V44.22Z" fill="black"/>
                                    <path d="M100.32 44.22H97.02V47.52H100.32V44.22Z" fill="black"/>
                                    <path d="M106.92 44.22H103.62V47.52H106.92V44.22Z" fill="black"/>
                                    <path d="M110.22 44.22H106.92V47.52H110.22V44.22Z" fill="black"/>
                                    <path d="M116.82 44.22H113.52V47.52H116.82V44.22Z" fill="black"/>
                                    <path d="M14.52 47.52H11.22V50.82H14.52V47.52Z" fill="black"/>
                                    <path d="M21.12 47.52H17.82V50.82H21.12V47.52Z" fill="black"/>
                                    <path d="M24.42 47.52H21.12V50.82H24.42V47.52Z" fill="black"/>
                                    <path d="M27.72 47.52H24.42V50.82H27.72V47.52Z" fill="black"/>
                                    <path d="M40.92 47.52H37.62V50.82H40.92V47.52Z" fill="black"/>
                                    <path d="M47.52 47.52H44.22V50.82H47.52V47.52Z" fill="black"/>
                                    <path d="M50.82 47.52H47.52V50.82H50.82V47.52Z" fill="black"/>
                                    <path d="M60.72 47.52H57.42V50.82H60.72V47.52Z" fill="black"/>
                                    <path d="M67.32 47.52H64.02V50.82H67.32V47.52Z" fill="black"/>
                                    <path d="M80.52 47.52H77.22V50.82H80.52V47.52Z" fill="black"/>
                                    <path d="M87.12 47.52H83.82V50.82H87.12V47.52Z" fill="black"/>
                                    <path d="M90.42 47.52H87.12V50.82H90.42V47.52Z" fill="black"/>
                                    <path d="M93.72 47.52H90.42V50.82H93.72V47.52Z" fill="black"/>
                                    <path d="M97.02 47.52H93.72V50.82H97.02V47.52Z" fill="black"/>
                                    <path d="M100.32 47.52H97.02V50.82H100.32V47.52Z" fill="black"/>
                                    <path d="M103.62 47.52H100.32V50.82H103.62V47.52Z" fill="black"/>
                                    <path d="M106.92 47.52H103.62V50.82H106.92V47.52Z" fill="black"/>
                                    <path d="M113.52 47.52H110.22V50.82H113.52V47.52Z" fill="black"/>
                                    <path d="M24.42 50.8201H21.12V54.1201H24.42V50.8201Z" fill="black"/>
                                    <path d="M27.72 50.8201H24.42V54.1201H27.72V50.8201Z" fill="black"/>
                                    <path d="M34.32 50.8201H31.02V54.1201H34.32V50.8201Z" fill="black"/>
                                    <path d="M44.22 50.8201H40.92V54.1201H44.22V50.8201Z" fill="black"/>
                                    <path d="M47.52 50.8201H44.22V54.1201H47.52V50.8201Z" fill="black"/>
                                    <path d="M57.42 50.8201H54.12V54.1201H57.42V50.8201Z" fill="black"/>
                                    <path d="M60.72 50.8201H57.42V54.1201H60.72V50.8201Z" fill="black"/>
                                    <path d="M64.02 50.8201H60.72V54.1201H64.02V50.8201Z" fill="black"/>
                                    <path d="M67.32 50.8201H64.02V54.1201H67.32V50.8201Z" fill="black"/>
                                    <path d="M80.52 50.8201H77.22V54.1201H80.52V50.8201Z" fill="black"/>
                                    <path d="M90.42 50.8201H87.12V54.1201H90.42V50.8201Z" fill="black"/>
                                    <path d="M100.32 50.8201H97.02V54.1201H100.32V50.8201Z" fill="black"/>
                                    <path d="M103.62 50.8201H100.32V54.1201H103.62V50.8201Z" fill="black"/>
                                    <path d="M116.82 50.8201H113.52V54.1201H116.82V50.8201Z" fill="black"/>
                                    <path d="M120.12 50.8201H116.82V54.1201H120.12V50.8201Z" fill="black"/>
                                    <path d="M21.12 54.1201H17.82V57.4201H21.12V54.1201Z" fill="black"/>
                                    <path d="M37.62 54.1201H34.32V57.4201H37.62V54.1201Z" fill="black"/>
                                    <path d="M47.52 54.1201H44.22V57.4201H47.52V54.1201Z" fill="black"/>
                                    <path d="M54.12 54.1201H50.82V57.4201H54.12V54.1201Z" fill="black"/>
                                    <path d="M57.42 54.1201H54.12V57.4201H57.42V54.1201Z" fill="black"/>
                                    <path d="M64.02 54.1201H60.72V57.4201H64.02V54.1201Z" fill="black"/>
                                    <path d="M67.32 54.1201H64.02V57.4201H67.32V54.1201Z" fill="black"/>
                                    <path d="M73.92 54.1201H70.62V57.4201H73.92V54.1201Z" fill="black"/>
                                    <path d="M77.22 54.1201H73.92V57.4201H77.22V54.1201Z" fill="black"/>
                                    <path d="M80.52 54.1201H77.22V57.4201H80.52V54.1201Z" fill="black"/>
                                    <path d="M90.42 54.1201H87.12V57.4201H90.42V54.1201Z" fill="black"/>
                                    <path d="M100.32 54.1201H97.02V57.4201H100.32V54.1201Z" fill="black"/>
                                    <path d="M103.62 54.1201H100.32V57.4201H103.62V54.1201Z" fill="black"/>
                                    <path d="M116.82 54.1201H113.52V57.4201H116.82V54.1201Z" fill="black"/>
                                    <path d="M120.12 54.1201H116.82V57.4201H120.12V54.1201Z" fill="black"/>
                                    <path d="M21.12 57.4199H17.82V60.7199H21.12V57.4199Z" fill="black"/>
                                    <path d="M24.42 57.4199H21.12V60.7199H24.42V57.4199Z" fill="black"/>
                                    <path d="M27.72 57.4199H24.42V60.7199H27.72V57.4199Z" fill="black"/>
                                    <path d="M31.02 57.4199H27.72V60.7199H31.02V57.4199Z" fill="black"/>
                                    <path d="M34.32 57.4199H31.02V60.7199H34.32V57.4199Z" fill="black"/>
                                    <path d="M37.62 57.4199H34.32V60.7199H37.62V57.4199Z" fill="black"/>
                                    <path d="M47.52 57.4199H44.22V60.7199H47.52V57.4199Z" fill="black"/>
                                    <path d="M57.42 57.4199H54.12V60.7199H57.42V57.4199Z" fill="black"/>
                                    <path d="M60.72 57.4199H57.42V60.7199H60.72V57.4199Z" fill="black"/>
                                    <path d="M64.02 57.4199H60.72V60.7199H64.02V57.4199Z" fill="black"/>
                                    <path d="M67.32 57.4199H64.02V60.7199H67.32V57.4199Z" fill="black"/>
                                    <path d="M70.62 57.4199H67.32V60.7199H70.62V57.4199Z" fill="black"/>
                                    <path d="M73.92 57.4199H70.62V60.7199H73.92V57.4199Z" fill="black"/>
                                    <path d="M80.52 57.4199H77.22V60.7199H80.52V57.4199Z" fill="black"/>
                                    <path d="M83.82 57.4199H80.52V60.7199H83.82V57.4199Z" fill="black"/>
                                    <path d="M97.02 57.4199H93.72V60.7199H97.02V57.4199Z" fill="black"/>
                                    <path d="M106.92 57.4199H103.62V60.7199H106.92V57.4199Z" fill="black"/>
                                    <path d="M116.82 57.4199H113.52V60.7199H116.82V57.4199Z" fill="black"/>
                                    <path d="M14.52 60.72H11.22V64.02H14.52V60.72Z" fill="black"/>
                                    <path d="M17.82 60.72H14.52V64.02H17.82V60.72Z" fill="black"/>
                                    <path d="M21.12 60.72H17.82V64.02H21.12V60.72Z" fill="black"/>
                                    <path d="M24.42 60.72H21.12V64.02H24.42V60.72Z" fill="black"/>
                                    <path d="M31.02 60.72H27.72V64.02H31.02V60.72Z" fill="black"/>
                                    <path d="M44.22 60.72H40.92V64.02H44.22V60.72Z" fill="black"/>
                                    <path d="M47.52 60.72H44.22V64.02H47.52V60.72Z" fill="black"/>
                                    <path d="M54.12 60.72H50.82V64.02H54.12V60.72Z" fill="black"/>
                                    <path d="M57.42 60.72H54.12V64.02H57.42V60.72Z" fill="black"/>
                                    <path d="M60.72 60.72H57.42V64.02H60.72V60.72Z" fill="black"/>
                                    <path d="M80.52 60.72H77.22V64.02H80.52V60.72Z" fill="black"/>
                                    <path d="M90.42 60.72H87.12V64.02H90.42V60.72Z" fill="black"/>
                                    <path d="M97.02 60.72H93.72V64.02H97.02V60.72Z" fill="black"/>
                                    <path d="M103.62 60.72H100.32V64.02H103.62V60.72Z" fill="black"/>
                                    <path d="M106.92 60.72H103.62V64.02H106.92V60.72Z" fill="black"/>
                                    <path d="M113.52 60.72H110.22V64.02H113.52V60.72Z" fill="black"/>
                                    <path d="M120.12 60.72H116.82V64.02H120.12V60.72Z" fill="black"/>
                                    <path d="M14.52 64.02H11.22V67.32H14.52V64.02Z" fill="black"/>
                                    <path d="M21.12 64.02H17.82V67.32H21.12V64.02Z" fill="black"/>
                                    <path d="M34.32 64.02H31.02V67.32H34.32V64.02Z" fill="black"/>
                                    <path d="M54.12 64.02H50.82V67.32H54.12V64.02Z" fill="black"/>
                                    <path d="M60.72 64.02H57.42V67.32H60.72V64.02Z" fill="black"/>
                                    <path d="M70.62 64.02H67.32V67.32H70.62V64.02Z" fill="black"/>
                                    <path d="M77.22 64.02H73.92V67.32H77.22V64.02Z" fill="black"/>
                                    <path d="M87.12 64.02H83.82V67.32H87.12V64.02Z" fill="black"/>
                                    <path d="M90.42 64.02H87.12V67.32H90.42V64.02Z" fill="black"/>
                                    <path d="M93.72 64.02H90.42V67.32H93.72V64.02Z" fill="black"/>
                                    <path d="M97.02 64.02H93.72V67.32H97.02V64.02Z" fill="black"/>
                                    <path d="M103.62 64.02H100.32V67.32H103.62V64.02Z" fill="black"/>
                                    <path d="M106.92 64.02H103.62V67.32H106.92V64.02Z" fill="black"/>
                                    <path d="M116.82 64.02H113.52V67.32H116.82V64.02Z" fill="black"/>
                                    <path d="M17.82 67.3201H14.52V70.6201H17.82V67.3201Z" fill="black"/>
                                    <path d="M24.42 67.3201H21.12V70.6201H24.42V67.3201Z" fill="black"/>
                                    <path d="M47.52 67.3201H44.22V70.6201H47.52V67.3201Z" fill="black"/>
                                    <path d="M64.02 67.3201H60.72V70.6201H64.02V67.3201Z" fill="black"/>
                                    <path d="M67.32 67.3201H64.02V70.6201H67.32V67.3201Z" fill="black"/>
                                    <path d="M70.62 67.3201H67.32V70.6201H70.62V67.3201Z" fill="black"/>
                                    <path d="M73.92 67.3201H70.62V70.6201H73.92V67.3201Z" fill="black"/>
                                    <path d="M77.22 67.3201H73.92V70.6201H77.22V67.3201Z" fill="black"/>
                                    <path d="M80.52 67.3201H77.22V70.6201H80.52V67.3201Z" fill="black"/>
                                    <path d="M87.12 67.3201H83.82V70.6201H87.12V67.3201Z" fill="black"/>
                                    <path d="M90.42 67.3201H87.12V70.6201H90.42V67.3201Z" fill="black"/>
                                    <path d="M93.72 67.3201H90.42V70.6201H93.72V67.3201Z" fill="black"/>
                                    <path d="M100.32 67.3201H97.02V70.6201H100.32V67.3201Z" fill="black"/>
                                    <path d="M103.62 67.3201H100.32V70.6201H103.62V67.3201Z" fill="black"/>
                                    <path d="M110.22 67.3201H106.92V70.6201H110.22V67.3201Z" fill="black"/>
                                    <path d="M116.82 67.3201H113.52V70.6201H116.82V67.3201Z" fill="black"/>
                                    <path d="M120.12 67.3201H116.82V70.6201H120.12V67.3201Z" fill="black"/>
                                    <path d="M14.52 70.6201H11.22V73.9201H14.52V70.6201Z" fill="black"/>
                                    <path d="M27.72 70.6201H24.42V73.9201H27.72V70.6201Z" fill="black"/>
                                    <path d="M34.32 70.6201H31.02V73.9201H34.32V70.6201Z" fill="black"/>
                                    <path d="M37.62 70.6201H34.32V73.9201H37.62V70.6201Z" fill="black"/>
                                    <path d="M40.92 70.6201H37.62V73.9201H40.92V70.6201Z" fill="black"/>
                                    <path d="M44.22 70.6201H40.92V73.9201H44.22V70.6201Z" fill="black"/>
                                    <path d="M47.52 70.6201H44.22V73.9201H47.52V70.6201Z" fill="black"/>
                                    <path d="M54.12 70.6201H50.82V73.9201H54.12V70.6201Z" fill="black"/>
                                    <path d="M57.42 70.6201H54.12V73.9201H57.42V70.6201Z" fill="black"/>
                                    <path d="M60.72 70.6201H57.42V73.9201H60.72V70.6201Z" fill="black"/>
                                    <path d="M64.02 70.6201H60.72V73.9201H64.02V70.6201Z" fill="black"/>
                                    <path d="M77.22 70.6201H73.92V73.9201H77.22V70.6201Z" fill="black"/>
                                    <path d="M83.82 70.6201H80.52V73.9201H83.82V70.6201Z" fill="black"/>
                                    <path d="M87.12 70.6201H83.82V73.9201H87.12V70.6201Z" fill="black"/>
                                    <path d="M90.42 70.6201H87.12V73.9201H90.42V70.6201Z" fill="black"/>
                                    <path d="M103.62 70.6201H100.32V73.9201H103.62V70.6201Z" fill="black"/>
                                    <path d="M120.12 70.6201H116.82V73.9201H120.12V70.6201Z" fill="black"/>
                                    <path d="M14.52 73.9199H11.22V77.2199H14.52V73.9199Z" fill="black"/>
                                    <path d="M17.82 73.9199H14.52V77.2199H17.82V73.9199Z" fill="black"/>
                                    <path d="M24.42 73.9199H21.12V77.2199H24.42V73.9199Z" fill="black"/>
                                    <path d="M44.22 73.9199H40.92V77.2199H44.22V73.9199Z" fill="black"/>
                                    <path d="M47.52 73.9199H44.22V77.2199H47.52V73.9199Z" fill="black"/>
                                    <path d="M50.82 73.9199H47.52V77.2199H50.82V73.9199Z" fill="black"/>
                                    <path d="M60.72 73.9199H57.42V77.2199H60.72V73.9199Z" fill="black"/>
                                    <path d="M64.02 73.9199H60.72V77.2199H64.02V73.9199Z" fill="black"/>
                                    <path d="M67.32 73.9199H64.02V77.2199H67.32V73.9199Z" fill="black"/>
                                    <path d="M103.62 73.9199H100.32V77.2199H103.62V73.9199Z" fill="black"/>
                                    <path d="M106.92 73.9199H103.62V77.2199H106.92V73.9199Z" fill="black"/>
                                    <path d="M113.52 73.9199H110.22V77.2199H113.52V73.9199Z" fill="black"/>
                                    <path d="M14.52 77.22H11.22V80.52H14.52V77.22Z" fill="black"/>
                                    <path d="M21.12 77.22H17.82V80.52H21.12V77.22Z" fill="black"/>
                                    <path d="M27.72 77.22H24.42V80.52H27.72V77.22Z" fill="black"/>
                                    <path d="M31.02 77.22H27.72V80.52H31.02V77.22Z" fill="black"/>
                                    <path d="M34.32 77.22H31.02V80.52H34.32V77.22Z" fill="black"/>
                                    <path d="M40.92 77.22H37.62V80.52H40.92V77.22Z" fill="black"/>
                                    <path d="M50.82 77.22H47.52V80.52H50.82V77.22Z" fill="black"/>
                                    <path d="M70.62 77.22H67.32V80.52H70.62V77.22Z" fill="black"/>
                                    <path d="M87.12 77.22H83.82V80.52H87.12V77.22Z" fill="black"/>
                                    <path d="M90.42 77.22H87.12V80.52H90.42V77.22Z" fill="black"/>
                                    <path d="M93.72 77.22H90.42V80.52H93.72V77.22Z" fill="black"/>
                                    <path d="M97.02 77.22H93.72V80.52H97.02V77.22Z" fill="black"/>
                                    <path d="M103.62 77.22H100.32V80.52H103.62V77.22Z" fill="black"/>
                                    <path d="M106.92 77.22H103.62V80.52H106.92V77.22Z" fill="black"/>
                                    <path d="M116.82 77.22H113.52V80.52H116.82V77.22Z" fill="black"/>
                                    <path d="M14.52 80.52H11.22V83.82H14.52V80.52Z" fill="black"/>
                                    <path d="M17.82 80.52H14.52V83.82H17.82V80.52Z" fill="black"/>
                                    <path d="M21.12 80.52H17.82V83.82H21.12V80.52Z" fill="black"/>
                                    <path d="M24.42 80.52H21.12V83.82H24.42V80.52Z" fill="black"/>
                                    <path d="M27.72 80.52H24.42V83.82H27.72V80.52Z" fill="black"/>
                                    <path d="M44.22 80.52H40.92V83.82H44.22V80.52Z" fill="black"/>
                                    <path d="M54.12 80.52H50.82V83.82H54.12V80.52Z" fill="black"/>
                                    <path d="M57.42 80.52H54.12V83.82H57.42V80.52Z" fill="black"/>
                                    <path d="M64.02 80.52H60.72V83.82H64.02V80.52Z" fill="black"/>
                                    <path d="M70.62 80.52H67.32V83.82H70.62V80.52Z" fill="black"/>
                                    <path d="M73.92 80.52H70.62V83.82H73.92V80.52Z" fill="black"/>
                                    <path d="M77.22 80.52H73.92V83.82H77.22V80.52Z" fill="black"/>
                                    <path d="M90.42 80.52H87.12V83.82H90.42V80.52Z" fill="black"/>
                                    <path d="M106.92 80.52H103.62V83.82H106.92V80.52Z" fill="black"/>
                                    <path d="M110.22 80.52H106.92V83.82H110.22V80.52Z" fill="black"/>
                                    <path d="M116.82 80.52H113.52V83.82H116.82V80.52Z" fill="black"/>
                                    <path d="M14.52 83.8201H11.22V87.1201H14.52V83.8201Z" fill="black"/>
                                    <path d="M34.32 83.8201H31.02V87.1201H34.32V83.8201Z" fill="black"/>
                                    <path d="M47.52 83.8201H44.22V87.1201H47.52V83.8201Z" fill="black"/>
                                    <path d="M57.42 83.8201H54.12V87.1201H57.42V83.8201Z" fill="black"/>
                                    <path d="M60.72 83.8201H57.42V87.1201H60.72V83.8201Z" fill="black"/>
                                    <path d="M64.02 83.8201H60.72V87.1201H64.02V83.8201Z" fill="black"/>
                                    <path d="M83.82 83.8201H80.52V87.1201H83.82V83.8201Z" fill="black"/>
                                    <path d="M97.02 83.8201H93.72V87.1201H97.02V83.8201Z" fill="black"/>
                                    <path d="M110.22 83.8201H106.92V87.1201H110.22V83.8201Z" fill="black"/>
                                    <path d="M116.82 83.8201H113.52V87.1201H116.82V83.8201Z" fill="black"/>
                                    <path d="M14.52 87.1201H11.22V90.4201H14.52V87.1201Z" fill="black"/>
                                    <path d="M24.42 87.1201H21.12V90.4201H24.42V87.1201Z" fill="black"/>
                                    <path d="M27.72 87.1201H24.42V90.4201H27.72V87.1201Z" fill="black"/>
                                    <path d="M37.62 87.1201H34.32V90.4201H37.62V87.1201Z" fill="black"/>
                                    <path d="M54.12 87.1201H50.82V90.4201H54.12V87.1201Z" fill="black"/>
                                    <path d="M57.42 87.1201H54.12V90.4201H57.42V87.1201Z" fill="black"/>
                                    <path d="M67.32 87.1201H64.02V90.4201H67.32V87.1201Z" fill="black"/>
                                    <path d="M80.52 87.1201H77.22V90.4201H80.52V87.1201Z" fill="black"/>
                                    <path d="M90.42 87.1201H87.12V90.4201H90.42V87.1201Z" fill="black"/>
                                    <path d="M97.02 87.1201H93.72V90.4201H97.02V87.1201Z" fill="black"/>
                                    <path d="M106.92 87.1201H103.62V90.4201H106.92V87.1201Z" fill="black"/>
                                    <path d="M110.22 87.1201H106.92V90.4201H110.22V87.1201Z" fill="black"/>
                                    <path d="M113.52 87.1201H110.22V90.4201H113.52V87.1201Z" fill="black"/>
                                    <path d="M14.52 90.4199H11.22V93.7199H14.52V90.4199Z" fill="black"/>
                                    <path d="M17.82 90.4199H14.52V93.7199H17.82V90.4199Z" fill="black"/>
                                    <path d="M21.12 90.4199H17.82V93.7199H21.12V90.4199Z" fill="black"/>
                                    <path d="M27.72 90.4199H24.42V93.7199H27.72V90.4199Z" fill="black"/>
                                    <path d="M34.32 90.4199H31.02V93.7199H34.32V90.4199Z" fill="black"/>
                                    <path d="M47.52 90.4199H44.22V93.7199H47.52V90.4199Z" fill="black"/>
                                    <path d="M50.82 90.4199H47.52V93.7199H50.82V90.4199Z" fill="black"/>
                                    <path d="M54.12 90.4199H50.82V93.7199H54.12V90.4199Z" fill="black"/>
                                    <path d="M57.42 90.4199H54.12V93.7199H57.42V90.4199Z" fill="black"/>
                                    <path d="M64.02 90.4199H60.72V93.7199H64.02V90.4199Z" fill="black"/>
                                    <path d="M67.32 90.4199H64.02V93.7199H67.32V90.4199Z" fill="black"/>
                                    <path d="M73.92 90.4199H70.62V93.7199H73.92V90.4199Z" fill="black"/>
                                    <path d="M77.22 90.4199H73.92V93.7199H77.22V90.4199Z" fill="black"/>
                                    <path d="M93.72 90.4199H90.42V93.7199H93.72V90.4199Z" fill="black"/>
                                    <path d="M97.02 90.4199H93.72V93.7199H97.02V90.4199Z" fill="black"/>
                                    <path d="M100.32 90.4199H97.02V93.7199H100.32V90.4199Z" fill="black"/>
                                    <path d="M103.62 90.4199H100.32V93.7199H103.62V90.4199Z" fill="black"/>
                                    <path d="M106.92 90.4199H103.62V93.7199H106.92V90.4199Z" fill="black"/>
                                    <path d="M116.82 90.4199H113.52V93.7199H116.82V90.4199Z" fill="black"/>
                                    <path d="M40.92 93.72H37.62V97.02H40.92V93.72Z" fill="black"/>
                                    <path d="M47.52 93.72H44.22V97.02H47.52V93.72Z" fill="black"/>
                                    <path d="M64.02 93.72H60.72V97.02H64.02V93.72Z" fill="black"/>
                                    <path d="M67.32 93.72H64.02V97.02H67.32V93.72Z" fill="black"/>
                                    <path d="M70.62 93.72H67.32V97.02H70.62V93.72Z" fill="black"/>
                                    <path d="M73.92 93.72H70.62V97.02H73.92V93.72Z" fill="black"/>
                                    <path d="M77.22 93.72H73.92V97.02H77.22V93.72Z" fill="black"/>
                                    <path d="M80.52 93.72H77.22V97.02H80.52V93.72Z" fill="black"/>
                                    <path d="M87.12 93.72H83.82V97.02H87.12V93.72Z" fill="black"/>
                                    <path d="M93.72 93.72H90.42V97.02H93.72V93.72Z" fill="black"/>
                                    <path d="M106.92 93.72H103.62V97.02H106.92V93.72Z" fill="black"/>
                                    <path d="M113.52 93.72H110.22V97.02H113.52V93.72Z" fill="black"/>
                                    <path d="M120.12 93.72H116.82V97.02H120.12V93.72Z" fill="black"/>
                                    <path d="M14.52 97.02H11.22V100.32H14.52V97.02Z" fill="black"/>
                                    <path d="M17.82 97.02H14.52V100.32H17.82V97.02Z" fill="black"/>
                                    <path d="M21.12 97.02H17.82V100.32H21.12V97.02Z" fill="black"/>
                                    <path d="M24.42 97.02H21.12V100.32H24.42V97.02Z" fill="black"/>
                                    <path d="M27.72 97.02H24.42V100.32H27.72V97.02Z" fill="black"/>
                                    <path d="M31.02 97.02H27.72V100.32H31.02V97.02Z" fill="black"/>
                                    <path d="M34.32 97.02H31.02V100.32H34.32V97.02Z" fill="black"/>
                                    <path d="M40.92 97.02H37.62V100.32H40.92V97.02Z" fill="black"/>
                                    <path d="M47.52 97.02H44.22V100.32H47.52V97.02Z" fill="black"/>
                                    <path d="M50.82 97.02H47.52V100.32H50.82V97.02Z" fill="black"/>
                                    <path d="M54.12 97.02H50.82V100.32H54.12V97.02Z" fill="black"/>
                                    <path d="M64.02 97.02H60.72V100.32H64.02V97.02Z" fill="black"/>
                                    <path d="M70.62 97.02H67.32V100.32H70.62V97.02Z" fill="black"/>
                                    <path d="M80.52 97.02H77.22V100.32H80.52V97.02Z" fill="black"/>
                                    <path d="M90.42 97.02H87.12V100.32H90.42V97.02Z" fill="black"/>
                                    <path d="M93.72 97.02H90.42V100.32H93.72V97.02Z" fill="black"/>
                                    <path d="M100.32 97.02H97.02V100.32H100.32V97.02Z" fill="black"/>
                                    <path d="M106.92 97.02H103.62V100.32H106.92V97.02Z" fill="black"/>
                                    <path d="M113.52 97.02H110.22V100.32H113.52V97.02Z" fill="black"/>
                                    <path d="M116.82 97.02H113.52V100.32H116.82V97.02Z" fill="black"/>
                                    <path d="M14.52 100.32H11.22V103.62H14.52V100.32Z" fill="black"/>
                                    <path d="M34.32 100.32H31.02V103.62H34.32V100.32Z" fill="black"/>
                                    <path d="M40.92 100.32H37.62V103.62H40.92V100.32Z" fill="black"/>
                                    <path d="M50.82 100.32H47.52V103.62H50.82V100.32Z" fill="black"/>
                                    <path d="M64.02 100.32H60.72V103.62H64.02V100.32Z" fill="black"/>
                                    <path d="M73.92 100.32H70.62V103.62H73.92V100.32Z" fill="black"/>
                                    <path d="M90.42 100.32H87.12V103.62H90.42V100.32Z" fill="black"/>
                                    <path d="M93.72 100.32H90.42V103.62H93.72V100.32Z" fill="black"/>
                                    <path d="M106.92 100.32H103.62V103.62H106.92V100.32Z" fill="black"/>
                                    <path d="M110.22 100.32H106.92V103.62H110.22V100.32Z" fill="black"/>
                                    <path d="M113.52 100.32H110.22V103.62H113.52V100.32Z" fill="black"/>
                                    <path d="M14.52 103.62H11.22V106.92H14.52V103.62Z" fill="black"/>
                                    <path d="M21.12 103.62H17.82V106.92H21.12V103.62Z" fill="black"/>
                                    <path d="M24.42 103.62H21.12V106.92H24.42V103.62Z" fill="black"/>
                                    <path d="M27.72 103.62H24.42V106.92H27.72V103.62Z" fill="black"/>
                                    <path d="M34.32 103.62H31.02V106.92H34.32V103.62Z" fill="black"/>
                                    <path d="M44.22 103.62H40.92V106.92H44.22V103.62Z" fill="black"/>
                                    <path d="M47.52 103.62H44.22V106.92H47.52V103.62Z" fill="black"/>
                                    <path d="M50.82 103.62H47.52V106.92H50.82V103.62Z" fill="black"/>
                                    <path d="M70.62 103.62H67.32V106.92H70.62V103.62Z" fill="black"/>
                                    <path d="M93.72 103.62H90.42V106.92H93.72V103.62Z" fill="black"/>
                                    <path d="M97.02 103.62H93.72V106.92H97.02V103.62Z" fill="black"/>
                                    <path d="M100.32 103.62H97.02V106.92H100.32V103.62Z" fill="black"/>
                                    <path d="M103.62 103.62H100.32V106.92H103.62V103.62Z" fill="black"/>
                                    <path d="M106.92 103.62H103.62V106.92H106.92V103.62Z" fill="black"/>
                                    <path d="M116.82 103.62H113.52V106.92H116.82V103.62Z" fill="black"/>
                                    <path d="M120.12 103.62H116.82V106.92H120.12V103.62Z" fill="black"/>
                                    <path d="M14.52 106.92H11.22V110.22H14.52V106.92Z" fill="black"/>
                                    <path d="M21.12 106.92H17.82V110.22H21.12V106.92Z" fill="black"/>
                                    <path d="M24.42 106.92H21.12V110.22H24.42V106.92Z" fill="black"/>
                                    <path d="M27.72 106.92H24.42V110.22H27.72V106.92Z" fill="black"/>
                                    <path d="M34.32 106.92H31.02V110.22H34.32V106.92Z" fill="black"/>
                                    <path d="M44.22 106.92H40.92V110.22H44.22V106.92Z" fill="black"/>
                                    <path d="M54.12 106.92H50.82V110.22H54.12V106.92Z" fill="black"/>
                                    <path d="M57.42 106.92H54.12V110.22H57.42V106.92Z" fill="black"/>
                                    <path d="M60.72 106.92H57.42V110.22H60.72V106.92Z" fill="black"/>
                                    <path d="M64.02 106.92H60.72V110.22H64.02V106.92Z" fill="black"/>
                                    <path d="M67.32 106.92H64.02V110.22H67.32V106.92Z" fill="black"/>
                                    <path d="M77.22 106.92H73.92V110.22H77.22V106.92Z" fill="black"/>
                                    <path d="M80.52 106.92H77.22V110.22H80.52V106.92Z" fill="black"/>
                                    <path d="M83.82 106.92H80.52V110.22H83.82V106.92Z" fill="black"/>
                                    <path d="M90.42 106.92H87.12V110.22H90.42V106.92Z" fill="black"/>
                                    <path d="M103.62 106.92H100.32V110.22H103.62V106.92Z" fill="black"/>
                                    <path d="M106.92 106.92H103.62V110.22H106.92V106.92Z" fill="black"/>
                                    <path d="M110.22 106.92H106.92V110.22H110.22V106.92Z" fill="black"/>
                                    <path d="M116.82 106.92H113.52V110.22H116.82V106.92Z" fill="black"/>
                                    <path d="M120.12 106.92H116.82V110.22H120.12V106.92Z" fill="black"/>
                                    <path d="M14.52 110.22H11.22V113.52H14.52V110.22Z" fill="black"/>
                                    <path d="M21.12 110.22H17.82V113.52H21.12V110.22Z" fill="black"/>
                                    <path d="M24.42 110.22H21.12V113.52H24.42V110.22Z" fill="black"/>
                                    <path d="M27.72 110.22H24.42V113.52H27.72V110.22Z" fill="black"/>
                                    <path d="M34.32 110.22H31.02V113.52H34.32V110.22Z" fill="black"/>
                                    <path d="M44.22 110.22H40.92V113.52H44.22V110.22Z" fill="black"/>
                                    <path d="M50.82 110.22H47.52V113.52H50.82V110.22Z" fill="black"/>
                                    <path d="M64.02 110.22H60.72V113.52H64.02V110.22Z" fill="black"/>
                                    <path d="M77.22 110.22H73.92V113.52H77.22V110.22Z" fill="black"/>
                                    <path d="M80.52 110.22H77.22V113.52H80.52V110.22Z" fill="black"/>
                                    <path d="M90.42 110.22H87.12V113.52H90.42V110.22Z" fill="black"/>
                                    <path d="M93.72 110.22H90.42V113.52H93.72V110.22Z" fill="black"/>
                                    <path d="M97.02 110.22H93.72V113.52H97.02V110.22Z" fill="black"/>
                                    <path d="M106.92 110.22H103.62V113.52H106.92V110.22Z" fill="black"/>
                                    <path d="M110.22 110.22H106.92V113.52H110.22V110.22Z" fill="black"/>
                                    <path d="M113.52 110.22H110.22V113.52H113.52V110.22Z" fill="black"/>
                                    <path d="M116.82 110.22H113.52V113.52H116.82V110.22Z" fill="black"/>
                                    <path d="M120.12 110.22H116.82V113.52H120.12V110.22Z" fill="black"/>
                                    <path d="M14.52 113.52H11.22V116.82H14.52V113.52Z" fill="black"/>
                                    <path d="M34.32 113.52H31.02V116.82H34.32V113.52Z" fill="black"/>
                                    <path d="M40.92 113.52H37.62V116.82H40.92V113.52Z" fill="black"/>
                                    <path d="M44.22 113.52H40.92V116.82H44.22V113.52Z" fill="black"/>
                                    <path d="M47.52 113.52H44.22V116.82H47.52V113.52Z" fill="black"/>
                                    <path d="M54.12 113.52H50.82V116.82H54.12V113.52Z" fill="black"/>
                                    <path d="M57.42 113.52H54.12V116.82H57.42V113.52Z" fill="black"/>
                                    <path d="M73.92 113.52H70.62V116.82H73.92V113.52Z" fill="black"/>
                                    <path d="M80.52 113.52H77.22V116.82H80.52V113.52Z" fill="black"/>
                                    <path d="M87.12 113.52H83.82V116.82H87.12V113.52Z" fill="black"/>
                                    <path d="M97.02 113.52H93.72V116.82H97.02V113.52Z" fill="black"/>
                                    <path d="M100.32 113.52H97.02V116.82H100.32V113.52Z" fill="black"/>
                                    <path d="M103.62 113.52H100.32V116.82H103.62V113.52Z" fill="black"/>
                                    <path d="M110.22 113.52H106.92V116.82H110.22V113.52Z" fill="black"/>
                                    <path d="M113.52 113.52H110.22V116.82H113.52V113.52Z" fill="black"/>
                                    <path d="M14.52 116.82H11.22V120.12H14.52V116.82Z" fill="black"/>
                                    <path d="M17.82 116.82H14.52V120.12H17.82V116.82Z" fill="black"/>
                                    <path d="M21.12 116.82H17.82V120.12H21.12V116.82Z" fill="black"/>
                                    <path d="M24.42 116.82H21.12V120.12H24.42V116.82Z" fill="black"/>
                                    <path d="M27.72 116.82H24.42V120.12H27.72V116.82Z" fill="black"/>
                                    <path d="M31.02 116.82H27.72V120.12H31.02V116.82Z" fill="black"/>
                                    <path d="M34.32 116.82H31.02V120.12H34.32V116.82Z" fill="black"/>
                                    <path d="M40.92 116.82H37.62V120.12H40.92V116.82Z" fill="black"/>
                                    <path d="M44.22 116.82H40.92V120.12H44.22V116.82Z" fill="black"/>
                                    <path d="M47.52 116.82H44.22V120.12H47.52V116.82Z" fill="black"/>
                                    <path d="M54.12 116.82H50.82V120.12H54.12V116.82Z" fill="black"/>
                                    <path d="M60.72 116.82H57.42V120.12H60.72V116.82Z" fill="black"/>
                                    <path d="M70.62 116.82H67.32V120.12H70.62V116.82Z" fill="black"/>
                                    <path d="M87.12 116.82H83.82V120.12H87.12V116.82Z" fill="black"/>
                                    <path d="M90.42 116.82H87.12V120.12H90.42V116.82Z" fill="black"/>
                                    <path d="M93.72 116.82H90.42V120.12H93.72V116.82Z" fill="black"/>
                                    <path d="M100.32 116.82H97.02V120.12H100.32V116.82Z" fill="black"/>
                                    <path d="M103.62 116.82H100.32V120.12H103.62V116.82Z" fill="black"/>
                                    <path d="M116.82 116.82H113.52V120.12H116.82V116.82Z" fill="black"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_401_3452">
                                        <rect width="132" height="132" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>

                            <svg width="132" height="132" viewBox="0 0 132 132" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_401_3984)">
                                    <path d="M132 0H0V132H132V0Z" fill="white"/>
                                    <path d="M12.54 8.58008H8.58V12.5401H12.54V8.58008Z" fill="black"/>
                                    <path d="M16.5 8.58008H12.54V12.5401H16.5V8.58008Z" fill="black"/>
                                    <path d="M20.46 8.58008H16.5V12.5401H20.46V8.58008Z" fill="black"/>
                                    <path d="M24.42 8.58008H20.46V12.5401H24.42V8.58008Z" fill="black"/>
                                    <path d="M28.38 8.58008H24.42V12.5401H28.38V8.58008Z" fill="black"/>
                                    <path d="M32.34 8.58008H28.38V12.5401H32.34V8.58008Z" fill="black"/>
                                    <path d="M36.3 8.58008H32.34V12.5401H36.3V8.58008Z" fill="black"/>
                                    <path d="M48.18 8.58008H44.22V12.5401H48.18V8.58008Z" fill="black"/>
                                    <path d="M52.14 8.58008H48.18V12.5401H52.14V8.58008Z" fill="black"/>
                                    <path d="M56.1 8.58008H52.14V12.5401H56.1V8.58008Z" fill="black"/>
                                    <path d="M60.06 8.58008H56.1V12.5401H60.06V8.58008Z" fill="black"/>
                                    <path d="M64.02 8.58008H60.06V12.5401H64.02V8.58008Z" fill="black"/>
                                    <path d="M75.9 8.58008H71.94V12.5401H75.9V8.58008Z" fill="black"/>
                                    <path d="M79.86 8.58008H75.9V12.5401H79.86V8.58008Z" fill="black"/>
                                    <path d="M83.82 8.58008H79.86V12.5401H83.82V8.58008Z" fill="black"/>
                                    <path d="M87.78 8.58008H83.82V12.5401H87.78V8.58008Z" fill="black"/>
                                    <path d="M99.66 8.58008H95.7V12.5401H99.66V8.58008Z" fill="black"/>
                                    <path d="M103.62 8.58008H99.66V12.5401H103.62V8.58008Z" fill="black"/>
                                    <path d="M107.58 8.58008H103.62V12.5401H107.58V8.58008Z" fill="black"/>
                                    <path d="M111.54 8.58008H107.58V12.5401H111.54V8.58008Z" fill="black"/>
                                    <path d="M115.5 8.58008H111.54V12.5401H115.5V8.58008Z" fill="black"/>
                                    <path d="M119.46 8.58008H115.5V12.5401H119.46V8.58008Z" fill="black"/>
                                    <path d="M123.42 8.58008H119.46V12.5401H123.42V8.58008Z" fill="black"/>
                                    <path d="M12.54 12.54H8.58V16.5H12.54V12.54Z" fill="black"/>
                                    <path d="M36.3 12.54H32.34V16.5H36.3V12.54Z" fill="black"/>
                                    <path d="M44.22 12.54H40.26V16.5H44.22V12.54Z" fill="black"/>
                                    <path d="M71.94 12.54H67.98V16.5H71.94V12.54Z" fill="black"/>
                                    <path d="M75.9 12.54H71.94V16.5H75.9V12.54Z" fill="black"/>
                                    <path d="M79.86 12.54H75.9V16.5H79.86V12.54Z" fill="black"/>
                                    <path d="M91.74 12.54H87.78V16.5H91.74V12.54Z" fill="black"/>
                                    <path d="M99.66 12.54H95.7V16.5H99.66V12.54Z" fill="black"/>
                                    <path d="M123.42 12.54H119.46V16.5H123.42V12.54Z" fill="black"/>
                                    <path d="M12.54 16.5H8.58V20.46H12.54V16.5Z" fill="black"/>
                                    <path d="M20.46 16.5H16.5V20.46H20.46V16.5Z" fill="black"/>
                                    <path d="M24.42 16.5H20.46V20.46H24.42V16.5Z" fill="black"/>
                                    <path d="M28.38 16.5H24.42V20.46H28.38V16.5Z" fill="black"/>
                                    <path d="M36.3 16.5H32.34V20.46H36.3V16.5Z" fill="black"/>
                                    <path d="M48.18 16.5H44.22V20.46H48.18V16.5Z" fill="black"/>
                                    <path d="M67.98 16.5H64.02V20.46H67.98V16.5Z" fill="black"/>
                                    <path d="M75.9 16.5H71.94V20.46H75.9V16.5Z" fill="black"/>
                                    <path d="M91.74 16.5H87.78V20.46H91.74V16.5Z" fill="black"/>
                                    <path d="M99.66 16.5H95.7V20.46H99.66V16.5Z" fill="black"/>
                                    <path d="M107.58 16.5H103.62V20.46H107.58V16.5Z" fill="black"/>
                                    <path d="M111.54 16.5H107.58V20.46H111.54V16.5Z" fill="black"/>
                                    <path d="M115.5 16.5H111.54V20.46H115.5V16.5Z" fill="black"/>
                                    <path d="M123.42 16.5H119.46V20.46H123.42V16.5Z" fill="black"/>
                                    <path d="M12.54 20.46H8.58V24.42H12.54V20.46Z" fill="black"/>
                                    <path d="M20.46 20.46H16.5V24.42H20.46V20.46Z" fill="black"/>
                                    <path d="M24.42 20.46H20.46V24.42H24.42V20.46Z" fill="black"/>
                                    <path d="M28.38 20.46H24.42V24.42H28.38V20.46Z" fill="black"/>
                                    <path d="M36.3 20.46H32.34V24.42H36.3V20.46Z" fill="black"/>
                                    <path d="M44.22 20.46H40.26V24.42H44.22V20.46Z" fill="black"/>
                                    <path d="M64.02 20.46H60.06V24.42H64.02V20.46Z" fill="black"/>
                                    <path d="M67.98 20.46H64.02V24.42H67.98V20.46Z" fill="black"/>
                                    <path d="M71.94 20.46H67.98V24.42H71.94V20.46Z" fill="black"/>
                                    <path d="M75.9 20.46H71.94V24.42H75.9V20.46Z" fill="black"/>
                                    <path d="M79.86 20.46H75.9V24.42H79.86V20.46Z" fill="black"/>
                                    <path d="M87.78 20.46H83.82V24.42H87.78V20.46Z" fill="black"/>
                                    <path d="M99.66 20.46H95.7V24.42H99.66V20.46Z" fill="black"/>
                                    <path d="M107.58 20.46H103.62V24.42H107.58V20.46Z" fill="black"/>
                                    <path d="M111.54 20.46H107.58V24.42H111.54V20.46Z" fill="black"/>
                                    <path d="M115.5 20.46H111.54V24.42H115.5V20.46Z" fill="black"/>
                                    <path d="M123.42 20.46H119.46V24.42H123.42V20.46Z" fill="black"/>
                                    <path d="M12.54 24.4199H8.58V28.3799H12.54V24.4199Z" fill="black"/>
                                    <path d="M20.46 24.4199H16.5V28.3799H20.46V24.4199Z" fill="black"/>
                                    <path d="M24.42 24.4199H20.46V28.3799H24.42V24.4199Z" fill="black"/>
                                    <path d="M28.38 24.4199H24.42V28.3799H28.38V24.4199Z" fill="black"/>
                                    <path d="M36.3 24.4199H32.34V28.3799H36.3V24.4199Z" fill="black"/>
                                    <path d="M48.18 24.4199H44.22V28.3799H48.18V24.4199Z" fill="black"/>
                                    <path d="M52.14 24.4199H48.18V28.3799H52.14V24.4199Z" fill="black"/>
                                    <path d="M56.1 24.4199H52.14V28.3799H56.1V24.4199Z" fill="black"/>
                                    <path d="M60.06 24.4199H56.1V28.3799H60.06V24.4199Z" fill="black"/>
                                    <path d="M64.02 24.4199H60.06V28.3799H64.02V24.4199Z" fill="black"/>
                                    <path d="M75.9 24.4199H71.94V28.3799H75.9V24.4199Z" fill="black"/>
                                    <path d="M83.82 24.4199H79.86V28.3799H83.82V24.4199Z" fill="black"/>
                                    <path d="M87.78 24.4199H83.82V28.3799H87.78V24.4199Z" fill="black"/>
                                    <path d="M91.74 24.4199H87.78V28.3799H91.74V24.4199Z" fill="black"/>
                                    <path d="M99.66 24.4199H95.7V28.3799H99.66V24.4199Z" fill="black"/>
                                    <path d="M107.58 24.4199H103.62V28.3799H107.58V24.4199Z" fill="black"/>
                                    <path d="M111.54 24.4199H107.58V28.3799H111.54V24.4199Z" fill="black"/>
                                    <path d="M115.5 24.4199H111.54V28.3799H115.5V24.4199Z" fill="black"/>
                                    <path d="M123.42 24.4199H119.46V28.3799H123.42V24.4199Z" fill="black"/>
                                    <path d="M12.54 28.3799H8.58V32.3399H12.54V28.3799Z" fill="black"/>
                                    <path d="M36.3 28.3799H32.34V32.3399H36.3V28.3799Z" fill="black"/>
                                    <path d="M44.22 28.3799H40.26V32.3399H44.22V28.3799Z" fill="black"/>
                                    <path d="M48.18 28.3799H44.22V32.3399H48.18V28.3799Z" fill="black"/>
                                    <path d="M52.14 28.3799H48.18V32.3399H52.14V28.3799Z" fill="black"/>
                                    <path d="M60.06 28.3799H56.1V32.3399H60.06V28.3799Z" fill="black"/>
                                    <path d="M64.02 28.3799H60.06V32.3399H64.02V28.3799Z" fill="black"/>
                                    <path d="M67.98 28.3799H64.02V32.3399H67.98V28.3799Z" fill="black"/>
                                    <path d="M71.94 28.3799H67.98V32.3399H71.94V28.3799Z" fill="black"/>
                                    <path d="M75.9 28.3799H71.94V32.3399H75.9V28.3799Z" fill="black"/>
                                    <path d="M83.82 28.3799H79.86V32.3399H83.82V28.3799Z" fill="black"/>
                                    <path d="M91.74 28.3799H87.78V32.3399H91.74V28.3799Z" fill="black"/>
                                    <path d="M99.66 28.3799H95.7V32.3399H99.66V28.3799Z" fill="black"/>
                                    <path d="M123.42 28.3799H119.46V32.3399H123.42V28.3799Z" fill="black"/>
                                    <path d="M12.54 32.3401H8.58V36.3001H12.54V32.3401Z" fill="black"/>
                                    <path d="M16.5 32.3401H12.54V36.3001H16.5V32.3401Z" fill="black"/>
                                    <path d="M20.46 32.3401H16.5V36.3001H20.46V32.3401Z" fill="black"/>
                                    <path d="M24.42 32.3401H20.46V36.3001H24.42V32.3401Z" fill="black"/>
                                    <path d="M28.38 32.3401H24.42V36.3001H28.38V32.3401Z" fill="black"/>
                                    <path d="M32.34 32.3401H28.38V36.3001H32.34V32.3401Z" fill="black"/>
                                    <path d="M36.3 32.3401H32.34V36.3001H36.3V32.3401Z" fill="black"/>
                                    <path d="M44.22 32.3401H40.26V36.3001H44.22V32.3401Z" fill="black"/>
                                    <path d="M52.14 32.3401H48.18V36.3001H52.14V32.3401Z" fill="black"/>
                                    <path d="M60.06 32.3401H56.1V36.3001H60.06V32.3401Z" fill="black"/>
                                    <path d="M67.98 32.3401H64.02V36.3001H67.98V32.3401Z" fill="black"/>
                                    <path d="M75.9 32.3401H71.94V36.3001H75.9V32.3401Z" fill="black"/>
                                    <path d="M83.82 32.3401H79.86V36.3001H83.82V32.3401Z" fill="black"/>
                                    <path d="M91.74 32.3401H87.78V36.3001H91.74V32.3401Z" fill="black"/>
                                    <path d="M99.66 32.3401H95.7V36.3001H99.66V32.3401Z" fill="black"/>
                                    <path d="M103.62 32.3401H99.66V36.3001H103.62V32.3401Z" fill="black"/>
                                    <path d="M107.58 32.3401H103.62V36.3001H107.58V32.3401Z" fill="black"/>
                                    <path d="M111.54 32.3401H107.58V36.3001H111.54V32.3401Z" fill="black"/>
                                    <path d="M115.5 32.3401H111.54V36.3001H115.5V32.3401Z" fill="black"/>
                                    <path d="M119.46 32.3401H115.5V36.3001H119.46V32.3401Z" fill="black"/>
                                    <path d="M123.42 32.3401H119.46V36.3001H123.42V32.3401Z" fill="black"/>
                                    <path d="M48.18 36.3H44.22V40.26H48.18V36.3Z" fill="black"/>
                                    <path d="M60.06 36.3H56.1V40.26H60.06V36.3Z" fill="black"/>
                                    <path d="M71.94 36.3H67.98V40.26H71.94V36.3Z" fill="black"/>
                                    <path d="M75.9 36.3H71.94V40.26H75.9V36.3Z" fill="black"/>
                                    <path d="M87.78 36.3H83.82V40.26H87.78V36.3Z" fill="black"/>
                                    <path d="M91.74 36.3H87.78V40.26H91.74V36.3Z" fill="black"/>
                                    <path d="M12.54 40.26H8.58V44.22H12.54V40.26Z" fill="black"/>
                                    <path d="M16.5 40.26H12.54V44.22H16.5V40.26Z" fill="black"/>
                                    <path d="M20.46 40.26H16.5V44.22H20.46V40.26Z" fill="black"/>
                                    <path d="M24.42 40.26H20.46V44.22H24.42V40.26Z" fill="black"/>
                                    <path d="M28.38 40.26H24.42V44.22H28.38V40.26Z" fill="black"/>
                                    <path d="M36.3 40.26H32.34V44.22H36.3V40.26Z" fill="black"/>
                                    <path d="M40.26 40.26H36.3V44.22H40.26V40.26Z" fill="black"/>
                                    <path d="M44.22 40.26H40.26V44.22H44.22V40.26Z" fill="black"/>
                                    <path d="M48.18 40.26H44.22V44.22H48.18V40.26Z" fill="black"/>
                                    <path d="M64.02 40.26H60.06V44.22H64.02V40.26Z" fill="black"/>
                                    <path d="M67.98 40.26H64.02V44.22H67.98V40.26Z" fill="black"/>
                                    <path d="M79.86 40.26H75.9V44.22H79.86V40.26Z" fill="black"/>
                                    <path d="M87.78 40.26H83.82V44.22H87.78V40.26Z" fill="black"/>
                                    <path d="M95.7 40.26H91.74V44.22H95.7V40.26Z" fill="black"/>
                                    <path d="M103.62 40.26H99.66V44.22H103.62V40.26Z" fill="black"/>
                                    <path d="M111.54 40.26H107.58V44.22H111.54V40.26Z" fill="black"/>
                                    <path d="M119.46 40.26H115.5V44.22H119.46V40.26Z" fill="black"/>
                                    <path d="M20.46 44.22H16.5V48.18H20.46V44.22Z" fill="black"/>
                                    <path d="M24.42 44.22H20.46V48.18H24.42V44.22Z" fill="black"/>
                                    <path d="M40.26 44.22H36.3V48.18H40.26V44.22Z" fill="black"/>
                                    <path d="M44.22 44.22H40.26V48.18H44.22V44.22Z" fill="black"/>
                                    <path d="M56.1 44.22H52.14V48.18H56.1V44.22Z" fill="black"/>
                                    <path d="M60.06 44.22H56.1V48.18H60.06V44.22Z" fill="black"/>
                                    <path d="M87.78 44.22H83.82V48.18H87.78V44.22Z" fill="black"/>
                                    <path d="M91.74 44.22H87.78V48.18H91.74V44.22Z" fill="black"/>
                                    <path d="M95.7 44.22H91.74V48.18H95.7V44.22Z" fill="black"/>
                                    <path d="M99.66 44.22H95.7V48.18H99.66V44.22Z" fill="black"/>
                                    <path d="M107.58 44.22H103.62V48.18H107.58V44.22Z" fill="black"/>
                                    <path d="M123.42 44.22H119.46V48.18H123.42V44.22Z" fill="black"/>
                                    <path d="M12.54 48.1799H8.58V52.1399H12.54V48.1799Z" fill="black"/>
                                    <path d="M16.5 48.1799H12.54V52.1399H16.5V48.1799Z" fill="black"/>
                                    <path d="M24.42 48.1799H20.46V52.1399H24.42V48.1799Z" fill="black"/>
                                    <path d="M36.3 48.1799H32.34V52.1399H36.3V48.1799Z" fill="black"/>
                                    <path d="M40.26 48.1799H36.3V52.1399H40.26V48.1799Z" fill="black"/>
                                    <path d="M52.14 48.1799H48.18V52.1399H52.14V48.1799Z" fill="black"/>
                                    <path d="M67.98 48.1799H64.02V52.1399H67.98V48.1799Z" fill="black"/>
                                    <path d="M71.94 48.1799H67.98V52.1399H71.94V48.1799Z" fill="black"/>
                                    <path d="M75.9 48.1799H71.94V52.1399H75.9V48.1799Z" fill="black"/>
                                    <path d="M83.82 48.1799H79.86V52.1399H83.82V48.1799Z" fill="black"/>
                                    <path d="M91.74 48.1799H87.78V52.1399H91.74V48.1799Z" fill="black"/>
                                    <path d="M99.66 48.1799H95.7V52.1399H99.66V48.1799Z" fill="black"/>
                                    <path d="M103.62 48.1799H99.66V52.1399H103.62V48.1799Z" fill="black"/>
                                    <path d="M28.38 52.1399H24.42V56.0999H28.38V52.1399Z" fill="black"/>
                                    <path d="M32.34 52.1399H28.38V56.0999H32.34V52.1399Z" fill="black"/>
                                    <path d="M44.22 52.1399H40.26V56.0999H44.22V52.1399Z" fill="black"/>
                                    <path d="M56.1 52.1399H52.14V56.0999H56.1V52.1399Z" fill="black"/>
                                    <path d="M67.98 52.1399H64.02V56.0999H67.98V52.1399Z" fill="black"/>
                                    <path d="M71.94 52.1399H67.98V56.0999H71.94V52.1399Z" fill="black"/>
                                    <path d="M75.9 52.1399H71.94V56.0999H75.9V52.1399Z" fill="black"/>
                                    <path d="M83.82 52.1399H79.86V56.0999H83.82V52.1399Z" fill="black"/>
                                    <path d="M87.78 52.1399H83.82V56.0999H87.78V52.1399Z" fill="black"/>
                                    <path d="M95.7 52.1399H91.74V56.0999H95.7V52.1399Z" fill="black"/>
                                    <path d="M99.66 52.1399H95.7V56.0999H99.66V52.1399Z" fill="black"/>
                                    <path d="M107.58 52.1399H103.62V56.0999H107.58V52.1399Z" fill="black"/>
                                    <path d="M111.54 52.1399H107.58V56.0999H111.54V52.1399Z" fill="black"/>
                                    <path d="M119.46 52.1399H115.5V56.0999H119.46V52.1399Z" fill="black"/>
                                    <path d="M16.5 56.1001H12.54V60.0601H16.5V56.1001Z" fill="black"/>
                                    <path d="M32.34 56.1001H28.38V60.0601H32.34V56.1001Z" fill="black"/>
                                    <path d="M36.3 56.1001H32.34V60.0601H36.3V56.1001Z" fill="black"/>
                                    <path d="M40.26 56.1001H36.3V60.0601H40.26V56.1001Z" fill="black"/>
                                    <path d="M48.18 56.1001H44.22V60.0601H48.18V56.1001Z" fill="black"/>
                                    <path d="M52.14 56.1001H48.18V60.0601H52.14V56.1001Z" fill="black"/>
                                    <path d="M64.02 56.1001H60.06V60.0601H64.02V56.1001Z" fill="black"/>
                                    <path d="M71.94 56.1001H67.98V60.0601H71.94V56.1001Z" fill="black"/>
                                    <path d="M79.86 56.1001H75.9V60.0601H79.86V56.1001Z" fill="black"/>
                                    <path d="M103.62 56.1001H99.66V60.0601H103.62V56.1001Z" fill="black"/>
                                    <path d="M111.54 56.1001H107.58V60.0601H111.54V56.1001Z" fill="black"/>
                                    <path d="M115.5 56.1001H111.54V60.0601H115.5V56.1001Z" fill="black"/>
                                    <path d="M20.46 60.0601H16.5V64.0201H20.46V60.0601Z" fill="black"/>
                                    <path d="M28.38 60.0601H24.42V64.0201H28.38V60.0601Z" fill="black"/>
                                    <path d="M32.34 60.0601H28.38V64.0201H32.34V60.0601Z" fill="black"/>
                                    <path d="M40.26 60.0601H36.3V64.0201H40.26V60.0601Z" fill="black"/>
                                    <path d="M56.1 60.0601H52.14V64.0201H56.1V60.0601Z" fill="black"/>
                                    <path d="M60.06 60.0601H56.1V64.0201H60.06V60.0601Z" fill="black"/>
                                    <path d="M64.02 60.0601H60.06V64.0201H64.02V60.0601Z" fill="black"/>
                                    <path d="M75.9 60.0601H71.94V64.0201H75.9V60.0601Z" fill="black"/>
                                    <path d="M87.78 60.0601H83.82V64.0201H87.78V60.0601Z" fill="black"/>
                                    <path d="M91.74 60.0601H87.78V64.0201H91.74V60.0601Z" fill="black"/>
                                    <path d="M95.7 60.0601H91.74V64.0201H95.7V60.0601Z" fill="black"/>
                                    <path d="M99.66 60.0601H95.7V64.0201H99.66V60.0601Z" fill="black"/>
                                    <path d="M103.62 60.0601H99.66V64.0201H103.62V60.0601Z" fill="black"/>
                                    <path d="M107.58 60.0601H103.62V64.0201H107.58V60.0601Z" fill="black"/>
                                    <path d="M123.42 60.0601H119.46V64.0201H123.42V60.0601Z" fill="black"/>
                                    <path d="M12.54 64.02H8.58V67.98H12.54V64.02Z" fill="black"/>
                                    <path d="M16.5 64.02H12.54V67.98H16.5V64.02Z" fill="black"/>
                                    <path d="M20.46 64.02H16.5V67.98H20.46V64.02Z" fill="black"/>
                                    <path d="M32.34 64.02H28.38V67.98H32.34V64.02Z" fill="black"/>
                                    <path d="M36.3 64.02H32.34V67.98H36.3V64.02Z" fill="black"/>
                                    <path d="M64.02 64.02H60.06V67.98H64.02V64.02Z" fill="black"/>
                                    <path d="M67.98 64.02H64.02V67.98H67.98V64.02Z" fill="black"/>
                                    <path d="M71.94 64.02H67.98V67.98H71.94V64.02Z" fill="black"/>
                                    <path d="M75.9 64.02H71.94V67.98H75.9V64.02Z" fill="black"/>
                                    <path d="M83.82 64.02H79.86V67.98H83.82V64.02Z" fill="black"/>
                                    <path d="M95.7 64.02H91.74V67.98H95.7V64.02Z" fill="black"/>
                                    <path d="M107.58 64.02H103.62V67.98H107.58V64.02Z" fill="black"/>
                                    <path d="M111.54 64.02H107.58V67.98H111.54V64.02Z" fill="black"/>
                                    <path d="M115.5 64.02H111.54V67.98H115.5V64.02Z" fill="black"/>
                                    <path d="M20.46 67.98H16.5V71.94H20.46V67.98Z" fill="black"/>
                                    <path d="M24.42 67.98H20.46V71.94H24.42V67.98Z" fill="black"/>
                                    <path d="M32.34 67.98H28.38V71.94H32.34V67.98Z" fill="black"/>
                                    <path d="M67.98 67.98H64.02V71.94H67.98V67.98Z" fill="black"/>
                                    <path d="M71.94 67.98H67.98V71.94H71.94V67.98Z" fill="black"/>
                                    <path d="M75.9 67.98H71.94V71.94H75.9V67.98Z" fill="black"/>
                                    <path d="M83.82 67.98H79.86V71.94H83.82V67.98Z" fill="black"/>
                                    <path d="M87.78 67.98H83.82V71.94H87.78V67.98Z" fill="black"/>
                                    <path d="M91.74 67.98H87.78V71.94H91.74V67.98Z" fill="black"/>
                                    <path d="M107.58 67.98H103.62V71.94H107.58V67.98Z" fill="black"/>
                                    <path d="M119.46 67.98H115.5V71.94H119.46V67.98Z" fill="black"/>
                                    <path d="M12.54 71.9399H8.58V75.8999H12.54V71.9399Z" fill="black"/>
                                    <path d="M16.5 71.9399H12.54V75.8999H16.5V71.9399Z" fill="black"/>
                                    <path d="M24.42 71.9399H20.46V75.8999H24.42V71.9399Z" fill="black"/>
                                    <path d="M36.3 71.9399H32.34V75.8999H36.3V71.9399Z" fill="black"/>
                                    <path d="M40.26 71.9399H36.3V75.8999H40.26V71.9399Z" fill="black"/>
                                    <path d="M44.22 71.9399H40.26V75.8999H44.22V71.9399Z" fill="black"/>
                                    <path d="M64.02 71.9399H60.06V75.8999H64.02V71.9399Z" fill="black"/>
                                    <path d="M67.98 71.9399H64.02V75.8999H67.98V71.9399Z" fill="black"/>
                                    <path d="M79.86 71.9399H75.9V75.8999H79.86V71.9399Z" fill="black"/>
                                    <path d="M83.82 71.9399H79.86V75.8999H83.82V71.9399Z" fill="black"/>
                                    <path d="M87.78 71.9399H83.82V75.8999H87.78V71.9399Z" fill="black"/>
                                    <path d="M103.62 71.9399H99.66V75.8999H103.62V71.9399Z" fill="black"/>
                                    <path d="M111.54 71.9399H107.58V75.8999H111.54V71.9399Z" fill="black"/>
                                    <path d="M115.5 71.9399H111.54V75.8999H115.5V71.9399Z" fill="black"/>
                                    <path d="M12.54 75.8999H8.58V79.8599H12.54V75.8999Z" fill="black"/>
                                    <path d="M40.26 75.8999H36.3V79.8599H40.26V75.8999Z" fill="black"/>
                                    <path d="M48.18 75.8999H44.22V79.8599H48.18V75.8999Z" fill="black"/>
                                    <path d="M52.14 75.8999H48.18V79.8599H52.14V75.8999Z" fill="black"/>
                                    <path d="M56.1 75.8999H52.14V79.8599H56.1V75.8999Z" fill="black"/>
                                    <path d="M60.06 75.8999H56.1V79.8599H60.06V75.8999Z" fill="black"/>
                                    <path d="M64.02 75.8999H60.06V79.8599H64.02V75.8999Z" fill="black"/>
                                    <path d="M75.9 75.8999H71.94V79.8599H75.9V75.8999Z" fill="black"/>
                                    <path d="M79.86 75.8999H75.9V79.8599H79.86V75.8999Z" fill="black"/>
                                    <path d="M83.82 75.8999H79.86V79.8599H83.82V75.8999Z" fill="black"/>
                                    <path d="M87.78 75.8999H83.82V79.8599H87.78V75.8999Z" fill="black"/>
                                    <path d="M99.66 75.8999H95.7V79.8599H99.66V75.8999Z" fill="black"/>
                                    <path d="M103.62 75.8999H99.66V79.8599H103.62V75.8999Z" fill="black"/>
                                    <path d="M107.58 75.8999H103.62V79.8599H107.58V75.8999Z" fill="black"/>
                                    <path d="M115.5 75.8999H111.54V79.8599H115.5V75.8999Z" fill="black"/>
                                    <path d="M123.42 75.8999H119.46V79.8599H123.42V75.8999Z" fill="black"/>
                                    <path d="M12.54 79.8601H8.58V83.8201H12.54V79.8601Z" fill="black"/>
                                    <path d="M24.42 79.8601H20.46V83.8201H24.42V79.8601Z" fill="black"/>
                                    <path d="M28.38 79.8601H24.42V83.8201H28.38V79.8601Z" fill="black"/>
                                    <path d="M32.34 79.8601H28.38V83.8201H32.34V79.8601Z" fill="black"/>
                                    <path d="M36.3 79.8601H32.34V83.8201H36.3V79.8601Z" fill="black"/>
                                    <path d="M40.26 79.8601H36.3V83.8201H40.26V79.8601Z" fill="black"/>
                                    <path d="M44.22 79.8601H40.26V83.8201H44.22V79.8601Z" fill="black"/>
                                    <path d="M48.18 79.8601H44.22V83.8201H48.18V79.8601Z" fill="black"/>
                                    <path d="M60.06 79.8601H56.1V83.8201H60.06V79.8601Z" fill="black"/>
                                    <path d="M71.94 79.8601H67.98V83.8201H71.94V79.8601Z" fill="black"/>
                                    <path d="M75.9 79.8601H71.94V83.8201H75.9V79.8601Z" fill="black"/>
                                    <path d="M79.86 79.8601H75.9V83.8201H79.86V79.8601Z" fill="black"/>
                                    <path d="M91.74 79.8601H87.78V83.8201H91.74V79.8601Z" fill="black"/>
                                    <path d="M95.7 79.8601H91.74V83.8201H95.7V79.8601Z" fill="black"/>
                                    <path d="M107.58 79.8601H103.62V83.8201H107.58V79.8601Z" fill="black"/>
                                    <path d="M115.5 79.8601H111.54V83.8201H115.5V79.8601Z" fill="black"/>
                                    <path d="M12.54 83.8201H8.58V87.7801H12.54V83.8201Z" fill="black"/>
                                    <path d="M24.42 83.8201H20.46V87.7801H24.42V83.8201Z" fill="black"/>
                                    <path d="M44.22 83.8201H40.26V87.7801H44.22V83.8201Z" fill="black"/>
                                    <path d="M48.18 83.8201H44.22V87.7801H48.18V83.8201Z" fill="black"/>
                                    <path d="M67.98 83.8201H64.02V87.7801H67.98V83.8201Z" fill="black"/>
                                    <path d="M75.9 83.8201H71.94V87.7801H75.9V83.8201Z" fill="black"/>
                                    <path d="M91.74 83.8201H87.78V87.7801H91.74V83.8201Z" fill="black"/>
                                    <path d="M95.7 83.8201H91.74V87.7801H95.7V83.8201Z" fill="black"/>
                                    <path d="M107.58 83.8201H103.62V87.7801H107.58V83.8201Z" fill="black"/>
                                    <path d="M119.46 83.8201H115.5V87.7801H119.46V83.8201Z" fill="black"/>
                                    <path d="M12.54 87.78H8.58V91.74H12.54V87.78Z" fill="black"/>
                                    <path d="M20.46 87.78H16.5V91.74H20.46V87.78Z" fill="black"/>
                                    <path d="M24.42 87.78H20.46V91.74H24.42V87.78Z" fill="black"/>
                                    <path d="M32.34 87.78H28.38V91.74H32.34V87.78Z" fill="black"/>
                                    <path d="M36.3 87.78H32.34V91.74H36.3V87.78Z" fill="black"/>
                                    <path d="M40.26 87.78H36.3V91.74H40.26V87.78Z" fill="black"/>
                                    <path d="M64.02 87.78H60.06V91.74H64.02V87.78Z" fill="black"/>
                                    <path d="M67.98 87.78H64.02V91.74H67.98V87.78Z" fill="black"/>
                                    <path d="M79.86 87.78H75.9V91.74H79.86V87.78Z" fill="black"/>
                                    <path d="M91.74 87.78H87.78V91.74H91.74V87.78Z" fill="black"/>
                                    <path d="M95.7 87.78H91.74V91.74H95.7V87.78Z" fill="black"/>
                                    <path d="M99.66 87.78H95.7V91.74H99.66V87.78Z" fill="black"/>
                                    <path d="M103.62 87.78H99.66V91.74H103.62V87.78Z" fill="black"/>
                                    <path d="M107.58 87.78H103.62V91.74H107.58V87.78Z" fill="black"/>
                                    <path d="M115.5 87.78H111.54V91.74H115.5V87.78Z" fill="black"/>
                                    <path d="M119.46 87.78H115.5V91.74H119.46V87.78Z" fill="black"/>
                                    <path d="M123.42 87.78H119.46V91.74H123.42V87.78Z" fill="black"/>
                                    <path d="M44.22 91.74H40.26V95.7H44.22V91.74Z" fill="black"/>
                                    <path d="M48.18 91.74H44.22V95.7H48.18V91.74Z" fill="black"/>
                                    <path d="M52.14 91.74H48.18V95.7H52.14V91.74Z" fill="black"/>
                                    <path d="M56.1 91.74H52.14V95.7H56.1V91.74Z" fill="black"/>
                                    <path d="M60.06 91.74H56.1V95.7H60.06V91.74Z" fill="black"/>
                                    <path d="M75.9 91.74H71.94V95.7H75.9V91.74Z" fill="black"/>
                                    <path d="M91.74 91.74H87.78V95.7H91.74V91.74Z" fill="black"/>
                                    <path d="M107.58 91.74H103.62V95.7H107.58V91.74Z" fill="black"/>
                                    <path d="M111.54 91.74H107.58V95.7H111.54V91.74Z" fill="black"/>
                                    <path d="M115.5 91.74H111.54V95.7H115.5V91.74Z" fill="black"/>
                                    <path d="M119.46 91.74H115.5V95.7H119.46V91.74Z" fill="black"/>
                                    <path d="M123.42 91.74H119.46V95.7H123.42V91.74Z" fill="black"/>
                                    <path d="M12.54 95.7H8.58V99.66H12.54V95.7Z" fill="black"/>
                                    <path d="M16.5 95.7H12.54V99.66H16.5V95.7Z" fill="black"/>
                                    <path d="M20.46 95.7H16.5V99.66H20.46V95.7Z" fill="black"/>
                                    <path d="M24.42 95.7H20.46V99.66H24.42V95.7Z" fill="black"/>
                                    <path d="M28.38 95.7H24.42V99.66H28.38V95.7Z" fill="black"/>
                                    <path d="M32.34 95.7H28.38V99.66H32.34V95.7Z" fill="black"/>
                                    <path d="M36.3 95.7H32.34V99.66H36.3V95.7Z" fill="black"/>
                                    <path d="M44.22 95.7H40.26V99.66H44.22V95.7Z" fill="black"/>
                                    <path d="M48.18 95.7H44.22V99.66H48.18V95.7Z" fill="black"/>
                                    <path d="M52.14 95.7H48.18V99.66H52.14V95.7Z" fill="black"/>
                                    <path d="M67.98 95.7H64.02V99.66H67.98V95.7Z" fill="black"/>
                                    <path d="M71.94 95.7H67.98V99.66H71.94V95.7Z" fill="black"/>
                                    <path d="M79.86 95.7H75.9V99.66H79.86V95.7Z" fill="black"/>
                                    <path d="M87.78 95.7H83.82V99.66H87.78V95.7Z" fill="black"/>
                                    <path d="M91.74 95.7H87.78V99.66H91.74V95.7Z" fill="black"/>
                                    <path d="M99.66 95.7H95.7V99.66H99.66V95.7Z" fill="black"/>
                                    <path d="M107.58 95.7H103.62V99.66H107.58V95.7Z" fill="black"/>
                                    <path d="M111.54 95.7H107.58V99.66H111.54V95.7Z" fill="black"/>
                                    <path d="M115.5 95.7H111.54V99.66H115.5V95.7Z" fill="black"/>
                                    <path d="M12.54 99.6599H8.58V103.62H12.54V99.6599Z" fill="black"/>
                                    <path d="M36.3 99.6599H32.34V103.62H36.3V99.6599Z" fill="black"/>
                                    <path d="M48.18 99.6599H44.22V103.62H48.18V99.6599Z" fill="black"/>
                                    <path d="M52.14 99.6599H48.18V103.62H52.14V99.6599Z" fill="black"/>
                                    <path d="M60.06 99.6599H56.1V103.62H60.06V99.6599Z" fill="black"/>
                                    <path d="M71.94 99.6599H67.98V103.62H71.94V99.6599Z" fill="black"/>
                                    <path d="M75.9 99.6599H71.94V103.62H75.9V99.6599Z" fill="black"/>
                                    <path d="M83.82 99.6599H79.86V103.62H83.82V99.6599Z" fill="black"/>
                                    <path d="M87.78 99.6599H83.82V103.62H87.78V99.6599Z" fill="black"/>
                                    <path d="M91.74 99.6599H87.78V103.62H91.74V99.6599Z" fill="black"/>
                                    <path d="M107.58 99.6599H103.62V103.62H107.58V99.6599Z" fill="black"/>
                                    <path d="M119.46 99.6599H115.5V103.62H119.46V99.6599Z" fill="black"/>
                                    <path d="M12.54 103.62H8.58V107.58H12.54V103.62Z" fill="black"/>
                                    <path d="M20.46 103.62H16.5V107.58H20.46V103.62Z" fill="black"/>
                                    <path d="M24.42 103.62H20.46V107.58H24.42V103.62Z" fill="black"/>
                                    <path d="M28.38 103.62H24.42V107.58H28.38V103.62Z" fill="black"/>
                                    <path d="M36.3 103.62H32.34V107.58H36.3V103.62Z" fill="black"/>
                                    <path d="M44.22 103.62H40.26V107.58H44.22V103.62Z" fill="black"/>
                                    <path d="M48.18 103.62H44.22V107.58H48.18V103.62Z" fill="black"/>
                                    <path d="M56.1 103.62H52.14V107.58H56.1V103.62Z" fill="black"/>
                                    <path d="M64.02 103.62H60.06V107.58H64.02V103.62Z" fill="black"/>
                                    <path d="M71.94 103.62H67.98V107.58H71.94V103.62Z" fill="black"/>
                                    <path d="M79.86 103.62H75.9V107.58H79.86V103.62Z" fill="black"/>
                                    <path d="M91.74 103.62H87.78V107.58H91.74V103.62Z" fill="black"/>
                                    <path d="M95.7 103.62H91.74V107.58H95.7V103.62Z" fill="black"/>
                                    <path d="M99.66 103.62H95.7V107.58H99.66V103.62Z" fill="black"/>
                                    <path d="M103.62 103.62H99.66V107.58H103.62V103.62Z" fill="black"/>
                                    <path d="M107.58 103.62H103.62V107.58H107.58V103.62Z" fill="black"/>
                                    <path d="M115.5 103.62H111.54V107.58H115.5V103.62Z" fill="black"/>
                                    <path d="M12.54 107.58H8.58V111.54H12.54V107.58Z" fill="black"/>
                                    <path d="M20.46 107.58H16.5V111.54H20.46V107.58Z" fill="black"/>
                                    <path d="M24.42 107.58H20.46V111.54H24.42V107.58Z" fill="black"/>
                                    <path d="M28.38 107.58H24.42V111.54H28.38V107.58Z" fill="black"/>
                                    <path d="M36.3 107.58H32.34V111.54H36.3V107.58Z" fill="black"/>
                                    <path d="M44.22 107.58H40.26V111.54H44.22V107.58Z" fill="black"/>
                                    <path d="M48.18 107.58H44.22V111.54H48.18V107.58Z" fill="black"/>
                                    <path d="M56.1 107.58H52.14V111.54H56.1V107.58Z" fill="black"/>
                                    <path d="M60.06 107.58H56.1V111.54H60.06V107.58Z" fill="black"/>
                                    <path d="M67.98 107.58H64.02V111.54H67.98V107.58Z" fill="black"/>
                                    <path d="M75.9 107.58H71.94V111.54H75.9V107.58Z" fill="black"/>
                                    <path d="M79.86 107.58H75.9V111.54H79.86V107.58Z" fill="black"/>
                                    <path d="M83.82 107.58H79.86V111.54H83.82V107.58Z" fill="black"/>
                                    <path d="M103.62 107.58H99.66V111.54H103.62V107.58Z" fill="black"/>
                                    <path d="M111.54 107.58H107.58V111.54H111.54V107.58Z" fill="black"/>
                                    <path d="M115.5 107.58H111.54V111.54H115.5V107.58Z" fill="black"/>
                                    <path d="M123.42 107.58H119.46V111.54H123.42V107.58Z" fill="black"/>
                                    <path d="M12.54 111.54H8.58V115.5H12.54V111.54Z" fill="black"/>
                                    <path d="M20.46 111.54H16.5V115.5H20.46V111.54Z" fill="black"/>
                                    <path d="M24.42 111.54H20.46V115.5H24.42V111.54Z" fill="black"/>
                                    <path d="M28.38 111.54H24.42V115.5H28.38V111.54Z" fill="black"/>
                                    <path d="M36.3 111.54H32.34V115.5H36.3V111.54Z" fill="black"/>
                                    <path d="M44.22 111.54H40.26V115.5H44.22V111.54Z" fill="black"/>
                                    <path d="M52.14 111.54H48.18V115.5H52.14V111.54Z" fill="black"/>
                                    <path d="M60.06 111.54H56.1V115.5H60.06V111.54Z" fill="black"/>
                                    <path d="M71.94 111.54H67.98V115.5H71.94V111.54Z" fill="black"/>
                                    <path d="M83.82 111.54H79.86V115.5H83.82V111.54Z" fill="black"/>
                                    <path d="M87.78 111.54H83.82V115.5H87.78V111.54Z" fill="black"/>
                                    <path d="M91.74 111.54H87.78V115.5H91.74V111.54Z" fill="black"/>
                                    <path d="M99.66 111.54H95.7V115.5H99.66V111.54Z" fill="black"/>
                                    <path d="M103.62 111.54H99.66V115.5H103.62V111.54Z" fill="black"/>
                                    <path d="M107.58 111.54H103.62V115.5H107.58V111.54Z" fill="black"/>
                                    <path d="M111.54 111.54H107.58V115.5H111.54V111.54Z" fill="black"/>
                                    <path d="M115.5 111.54H111.54V115.5H115.5V111.54Z" fill="black"/>
                                    <path d="M119.46 111.54H115.5V115.5H119.46V111.54Z" fill="black"/>
                                    <path d="M12.54 115.5H8.58V119.46H12.54V115.5Z" fill="black"/>
                                    <path d="M36.3 115.5H32.34V119.46H36.3V115.5Z" fill="black"/>
                                    <path d="M44.22 115.5H40.26V119.46H44.22V115.5Z" fill="black"/>
                                    <path d="M48.18 115.5H44.22V119.46H48.18V115.5Z" fill="black"/>
                                    <path d="M52.14 115.5H48.18V119.46H52.14V115.5Z" fill="black"/>
                                    <path d="M67.98 115.5H64.02V119.46H67.98V115.5Z" fill="black"/>
                                    <path d="M75.9 115.5H71.94V119.46H75.9V115.5Z" fill="black"/>
                                    <path d="M91.74 115.5H87.78V119.46H91.74V115.5Z" fill="black"/>
                                    <path d="M95.7 115.5H91.74V119.46H95.7V115.5Z" fill="black"/>
                                    <path d="M103.62 115.5H99.66V119.46H103.62V115.5Z" fill="black"/>
                                    <path d="M107.58 115.5H103.62V119.46H107.58V115.5Z" fill="black"/>
                                    <path d="M111.54 115.5H107.58V119.46H111.54V115.5Z" fill="black"/>
                                    <path d="M119.46 115.5H115.5V119.46H119.46V115.5Z" fill="black"/>
                                    <path d="M12.54 119.46H8.58V123.42H12.54V119.46Z" fill="black"/>
                                    <path d="M16.5 119.46H12.54V123.42H16.5V119.46Z" fill="black"/>
                                    <path d="M20.46 119.46H16.5V123.42H20.46V119.46Z" fill="black"/>
                                    <path d="M24.42 119.46H20.46V123.42H24.42V119.46Z" fill="black"/>
                                    <path d="M28.38 119.46H24.42V123.42H28.38V119.46Z" fill="black"/>
                                    <path d="M32.34 119.46H28.38V123.42H32.34V119.46Z" fill="black"/>
                                    <path d="M36.3 119.46H32.34V123.42H36.3V119.46Z" fill="black"/>
                                    <path d="M44.22 119.46H40.26V123.42H44.22V119.46Z" fill="black"/>
                                    <path d="M52.14 119.46H48.18V123.42H52.14V119.46Z" fill="black"/>
                                    <path d="M64.02 119.46H60.06V123.42H64.02V119.46Z" fill="black"/>
                                    <path d="M79.86 119.46H75.9V123.42H79.86V119.46Z" fill="black"/>
                                    <path d="M87.78 119.46H83.82V123.42H87.78V119.46Z" fill="black"/>
                                    <path d="M95.7 119.46H91.74V123.42H95.7V119.46Z" fill="black"/>
                                    <path d="M107.58 119.46H103.62V123.42H107.58V119.46Z" fill="black"/>
                                    <path d="M115.5 119.46H111.54V123.42H115.5V119.46Z" fill="black"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_401_3984">
                                        <rect width="132" height="132" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="home-section10-store-wrapper">
                            <a v-on:click="() => { storeClick(false) }" aria-label="Google Play Store Vindome app" href="https://play.google.com/store/apps/details?id=com.vindome.wine" target="_blank">
                                <svg width="132" height="40" viewBox="0 0 132 40" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <rect x="0.0909119" width="131.818" height="40" rx="4" fill="url(#pattern0)"/>
                                    <defs>
                                        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                                            <use xlink:href="#image0_401_3982" transform="scale(0.00689655 0.0227273)"/>
                                        </pattern>
                                        <image id="image0_401_3982" width="145" height="44" xlink:href="data:image/png;base64,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"/>
                                    </defs>
                                </svg>
                            </a>

                            <a v-on:click="() => { storeClick(true) }" aria-label="AppStore Vindome app" href="https://apps.apple.com/app/vindome-wine/id1494570524" target="_blank">
                                <svg width="120" height="40" viewBox="0 0 120 40" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <rect x="0.454544" width="119.091" height="40" fill="url(#pattern1)"/>
                                    <defs>
                                        <pattern id="pattern1" patternContentUnits="objectBoundingBox" width="1" height="1">
                                            <use xlink:href="#image0_401_4413" transform="scale(0.00763359 0.0227273)"/>
                                        </pattern>
                                        <image id="image0_401_4413" width="131" height="44" xlink:href="data:image/png;base64,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"/>
                                    </defs>
                                </svg>
                            </a>
                        </div>
                    </div>
                    <div class="home-section10-right">
                        <div class="home-section10-img">
                            <nuxt-img alt="chart image" v-if="$i18n.locale === 'it'" format="webp" provider="static" fit="cover" src="/section10_it.png" />
                            <nuxt-img alt="chart image" v-else-if="$i18n.locale === 'fr'" format="webp" provider="static" fit="cover" src="/section10_fr.png" />
                            <nuxt-img alt="chart image" v-else-if="$i18n.locale === 'de'" format="webp" provider="static" fit="cover" src="/section10_de.png" />
                            <nuxt-img alt="chart image" v-else-if="$i18n.locale === 'ru'" format="webp" provider="static" fit="cover" src="/section10_ru.png" />
                            <nuxt-img alt="chart image" v-else format="webp" provider="static" fit="cover" src="/section10_en.png" />
                        </div>
                    </div>
                </div>
            </section>
        </main>

        <v-dialog v-model="bookChat2" persistent max-width="800px">
            <v-card class="qr-popup expert-popup">
                <div class="qr-close" v-on:click="() => {bookChat2 = false}"></div>
                <iframe :src="iframeUrl"/>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showStore" persistent max-width="376px">
            <v-card class="qr-popup">
                <div class="qr-close" v-on:click="hideQR"></div>
                <div class="qr-title">{{ $t('download-app') }}</div>
                <div :class="{'qr-image': true, 'appStore': appStore, 'googlePlay': googlePlay}"></div>
                <div class="stores">
                    <a v-on:click="() => { storeClick(true) }" href="https://apps.apple.com/app/vindome-wine/id1494570524" target="_blank" class="appstore" v-if="appStore"></a>
                    <a v-on:click="() => { storeClick(false) }" href="https://play.google.com/store/apps/details?id=com.vindome.wine" target="_blank" class="gplay" v-if="googlePlay"></a>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="bookChat" persistent :max-width="nextStep ? '517px' : '817px'">
            <v-card :class="{'qr-popup zoho-popup': !nextStep, 'qr-popup zoho-popup2': nextStep, 'qr-popup-long': $i18n.locale !== 'en' }">
                <div class="qr-close" v-on:click="() => { bookChat = false }"></div>
                <div class="guide-content" v-if="!nextStep">
                    <div class="guide-reg-wrapper">
                        <div class="guide-title">{{ $t('guide1') }}</div>
                        <div class="guide-subtitle">{{ $t('guide2') }}</div>
                        <div class="mobile-back"></div>
                        <div class="reg-container">
                            <v-flex>
                                <span class="login-label">{{ $t('myprofile1') }} *</span>
                                <v-text-field
                                    id="regFName"
                                    ref="regFName"
                                    v-model="regFName"
                                    class="email-input"
                                    :rules="[rules.required]"
                                    :error="$v.regFName.$error"
                                ></v-text-field>
                            </v-flex>
                            <v-flex>
                                <span class="login-label">{{ $t('myprofile2') }} *</span>
                                <v-text-field
                                    v-model="regLName"
                                    class="email-input"
                                    :rules="[rules.required]"
                                    :error="$v.regLName.$error"
                                ></v-text-field>
                            </v-flex>
                            <v-flex>
                                <span class="login-label">Email *</span>
                                <v-text-field
                                    ref="email"
                                    v-model="regEmail"
                                    class="email-input"
                                    :rules="[rules.required, rules.emailValid]"
                                ></v-text-field>
                            </v-flex>
                            <v-flex>
                                <span class="login-label">Password *</span>
                                <v-text-field
                                    ref="regPassword"
                                    v-model="regPassword"
                                    :append-icon="secureRegPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                    :rules="[rules.required, rules.min]"
                                    :type="secureRegPassword ? 'password' : 'text'"
                                    name="input-10-1"
                                    hint="At least 8 characters"
                                    counter
                                    @click:append="secureRegPassword = !secureRegPassword"
                                    v-on:keyup.enter="registration"
                                >
                                </v-text-field>
                            </v-flex>
                            <v-checkbox
                                v-model="checked18"
                                :label="$t('register-confirm18')"
                            ></v-checkbox>
                            <v-checkbox
                                v-model="checkedTerms"
                                class="check-terms"
                            >
                                <div slot="label">
                                    {{ $t('register-terms') }}
                                </div>
                            </v-checkbox>
                            <v-checkbox
                                v-model="checkedNews"
                                :label="$t('register-news')"
                                class="check-terms"
                            ></v-checkbox>
                            <v-flex>
                                <div class="errors-container2" v-if="errorMsg !== ''">
                                    <p>{{ errorMsg }}</p>
                                </div>
                            </v-flex>
                            <v-flex>
                                <v-btn class="submit login-submit" v-on:click="registration">{{ $t('guide3') }}</v-btn>
                            </v-flex>
                        </div>
                    </div>
                </div>
                <div class="login-inner-container" v-else>
                    <div class="login-success">
                        <h2>Account created successfully</h2>
                        <div class="additional-info">
                            Check your email for an account activation link!
                        </div>
                    </div>

                    <div class="login-success-btn-wrapper">
                        <v-btn class="btn-primary btn-bid-proceed" v-on:click="goToLogin">OK</v-btn>
                        <v-btn class="btn-bid-cancel" v-on:click="resendMail">Resend email</v-btn>
                    </div>
                </div>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import {VueperSlides, VueperSlide} from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import {GCommon, GUser} from "@/store/getters";
import {email, minLength, required} from "vuelidate/lib/validators";
import {AAuth} from "@/store/actions";

export default {
    name: "home",
    head() {
        return {
            title: 'Vindome Smart Wine Investments | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
            bodyAttrs: {
                class: 'home'
            }
        }
    },
    validations: {
        regFName: {
            required
        },
        regLName: {
            required
        },
        regEmail: {
            required,
            email
        },
        regPassword: {
            required,
            minLength: minLength(8)
        }
    },
    components: {
        VueperSlides,
        VueperSlide,
        HomeWineSlider: () => (process.client && window.scrollY > 499) ? import('../../components/home/HomeWineSlider') : null,
        HomeTestimonials: () => (process.client && window.scrollY > 499) ? import('../../components/home/HomeTestimonials') : null
    },
    data() {
        return {
            showBlogSection: false,
            bookChat: false,
            bookChat2: false,
            show: false,
            showStore: false,
            nextStep: false,
            alreadyShown: false,
            appStore: false,
            googlePlay: false,
            blogPosts: [],
            selectedTab: 0,
            regEmail: '',
            regPassword: '',
            regFName: '',
            regLName: '',
            countryId: 224,
            isLoading: false,
            checkedTerms: false,
            checked18: false,
            checkedNews: true,
            secureRegPassword: true,
            reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
            rules: {
                required: value => !!value || 'Required.',
                min: value => value.length >= 8 || 'Min 8 characters',
                emailValid: value => this.isEmailValid(value) || 'Invalid email'
            },
            errorMsg: ''
        };
    },
    computed: {
        ...mapGetters({
            mobileCheck: GCommon.GET_MOBILE_VERSION,
            isLogged: GUser.GET_USER_LOGGED
        }),
        iframeUrl() {
            let _url = 'https://forms.zohopublic.eu/vindome/form/EnPrimeurDailyReportSignUp/formperma/ntcZNvLn1UQbFDUQxMZ1z4tDZ8IphnwlGm1J3D24ZiA'

            if (this.$i18n.locale === 'it') {
                _url = 'https://forms.zohopublic.eu/vindome/form/TalktoaWineInvestmentExpertIT/formperma/L5S7SjLQAzMpTYdmRJpE13XLNIR8PfBut-0BM2T0hM4?zf_lang=it'
            } else if (this.$i18n.locale === 'de') {
                _url = 'https://forms.zohopublic.eu/vindome/form/TalktoaWineInvestmentExpertGermany/formperma/mppI-WpFHLAX4-dkKCvW1_v0W-mGwfpVDSAMKnSDmt8?zf_lang=de'
            } else if (this.$i18n.locale === 'fr') {
                _url = 'https://forms.zohopublic.eu/vindome/form/TalktoaWineInvestmentExpert/formperma/XW6QTfH62YOljh7kD80CWJiQ2YMlaV2opC2pERi4WnA?zf_lang=fr'
            }

            return _url
        }
    },
    methods: {
        ...mapActions({
            signup: AAuth.REG_USER,
            sendMail: AAuth.SEND_MAIL
        }),
        isEmailValid: function (email) {
            return this.reg.test(email)
        },
        goToLogin() {
            this.$router.push(this.localePath({path: '/login'}));
        },
        resendMail() {
            this.sendMail(this.regEmail)
        },
        registration() {
            this.$v.regFName.$touch();
            this.$v.regLName.$touch();
            if (this.regEmail && this.regPassword && !this.$v.regEmail.$invalid && !this.$v.regPassword.$invalid && !this.$v.regFName.$invalid && !this.$v.regLName.$invalid) {
                if (this.checkedTerms && this.checked18) {
                    this.isLoading = true;
                    let payload = {
                        email: this.regEmail,
                        password: this.regPassword,
                        confirmPassword: this.regPassword,
                        firstname: this.regFName,
                        lastname: this.regLName,
                        countryId: this.countryId,
                        phoneNumber: '',
                        name: '',
                        enabledNotification: this.enabledNotification === true ? 1 : 0,
                        newsletter: this.checkedNews
                    };
                    this.signup(payload).then(res => {
                        if (res.reasonPhrase === "Created") {
                            this.nextStep = true;
                        }

                        this.$gtm.push({ event: "registration" });
                        window.fbq('track', 'CompleteRegistration');
                    }).catch(err => {
                        this.isLoading = false;
                        if (err.data.errors) {
                            if (err.data.errors.Email.length) {
                                err.data.errors.Email.forEach(err => {
                                    this.errorMsg = err;
                                })
                            } else if (err.data.errors.GeneralError.length) {
                                err.data.errors.GeneralError.forEach(err => {
                                    this.errorMsg = err;
                                })
                            } else {
                                this.errorMsg = 'Unexpected behavior. Please check your internet connection or try again later.';
                            }
                        }
                    })
                } else {
                    this.errorMsg = 'You must agree with the terms of service and confirm that you are at least 18 years old.';
                }
            } else {
                this.errorMsg = 'Please fill the above information.';
            }

        },
        storeClick(isAppStore) {
            this.$gtm.push({ event: isAppStore ? "AppStoreClick" : "GooglePlayClick" });
        },
        handleScroll() {
            if (window.scrollY > 499) {
                this.showBlogSection = true

                if (!this.isLogged && !this.alreadyShown) {
                    this.bookChat = true
                    this.alreadyShown = true
                }
            }
        },
        goSection(val) {
            this.$nuxt.$emit("goToSection", val);
        },
        getImgUrl(imgUrl) {
            return "background-image: url('" + imgUrl + "')"
        },
        hideQR() {
            this.showStore = false;
            this.appStore = false;
            this.googlePlay = false;
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);

        axios.get('https://blog.vindome.net/wp-json/wp/v2/posts?per_page=5').then((response) => {
            response.data.forEach(blog => {
                let _newBlogPost = {};
                _newBlogPost.title = blog.yoast_head_json.title.replace(' - Vindome Blog', '');
                _newBlogPost.subtitle = blog.yoast_head_json.description;
                _newBlogPost.link = blog.link;
                _newBlogPost.img = blog.jetpack_featured_media_url;

                this.blogPosts.push(_newBlogPost)
            })
        });
    },
    destroyed() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('scroll', this.handleScroll);
        }
    }
};
</script>

<style scoped>
.errors-container2 {
    height: auto;
    width: 100%;
    background: transparent;
    margin: 0;
}

.errors-container2 p {
    color: #D75353;
    line-height: 12px;
    font-size: var(--fs-small);
    padding-left: 0;
    margin-bottom: 0;
    padding-top: 5;
}

.login-success {
    background: url("../../assets/how/ok.gif") no-repeat center top;
    background-size: 250px;
    padding-top: 280px;
}
.login-inner-container {
    height: 100%;
    padding: 24px;
}
.login-success-btn-wrapper {
    text-align: center;
}

.theme--light.v-btn.v-btn--has-bg.btn-bid-proceed {
    background: #004F7F;
    border-color: #004F7F;
    border-radius: 8px;
    padding: 8px 16px;
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    color: #FFFFFF;
    margin-right: 16px;
}

.theme--light.v-btn.v-btn--has-bg.btn-bid-cancel {
    border: 1px solid #004F7F;
    border-radius: 8px;
    padding: 8px 16px;
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    color: #004F7F;
}
.login-success h2 {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    color: #002840;
    text-align: center;
}
.qr-popup.expert-popup.v-card {
    background: #f2f3f6;
    height: 630px;
}
.expert-popup iframe {
    width: 100%;
    height: 600px;
    border: 0;
    border-radius: 24px;
}
.qr-popup.v-card {
    border-radius: 24px;
    height: 421px;
}

.qr-popup.v-card.zoho-popup {
    height: 556px;
    width: 817px;
    overflow: hidden;
    background: #fff url("../../assets/how/guide2.png") no-repeat right top;
    background-position-x: 422px;
    padding-bottom: 0;
}
.qr-popup.v-card.zoho-popup.qr-popup-long {
    height: 585px;
}

.qr-popup.v-card.zoho-popup2 {
    height: 506px;
    width: 517px;
    overflow: hidden;
    background: #f4f4f4;
    padding-bottom: 0;
}

.guide-content {
    height: 100%;
    padding: 24px;
    background: url("../../assets/how/guide1.png") no-repeat right bottom;
    background-size: 510px;
}
.guide-reg-wrapper {
    width: 382px;
}

.guide-title {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    color: #002840;
    margin-bottom: 8px;
}

.guide-subtitle {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: #002840;
}

.qr-close {
    position: absolute;
    z-index: 1;
    top: 16px;
    right: 16px;
    width: 40px;
    height: 40px;
    border-radius: 55%;
    background: url("../../assets/icon-close.svg") no-repeat center;
}

.qr-close:hover {
    background-color: #f1e2c4;
    cursor: pointer;
}
.reg-container {
    margin-top: 16px;
}

.slide-bg {
    height: 240px;
    background-size: cover;
    background-position: center;
    width: 100%;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
}

.errors-container {
    padding-left: 10px;
}
.gift-left,
.gift-right {
    display: inline-block;
}
.gift-right {
    display: inline-block;
    width: 320px;
    text-align: right;
}
.gift-left {
    width: calc(100% - 320px);
}
.why-invest-wrapper {
    background: #f6f6f6;
    padding: 30px 0;
    margin-bottom: 35px;
}
.collections-h1 {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 40px;
    line-height: 120%;
    text-align: center;
    color: #303030;
    margin-bottom: 35px;
}
.card-icon {
    height: 80px;
    width: 100%;
    margin-bottom: 20px;
}
.card-title {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-size: 25px;
    line-height: 30px;
    margin-bottom: 16px;
    font-weight: 700;
    color: #303030;
    text-align: center;
    text-transform: uppercase;
}
.secure .card-icon {
    background: url("../../assets/home/secure.png") no-repeat center center;
    background-size: contain;
}
.sold .card-icon {
    background: url("../../assets/home/easy.png") no-repeat center center;
    background-size: contain;
}
.transparency .card-icon {
    background: url("../../assets/home/dynamic.png") no-repeat center center;
    background-size: contain;
}
.primeur1 .card-icon {
    background: url("../../assets/home/price.png") no-repeat center center;
    background-size: contain;
}
.primeur2 .card-icon {
    background: url("../../assets/home/chart.png") no-repeat center center;
    background-size: contain;
}
.primeur3 .card-icon {
    background: url("../../assets/home/lock.png") no-repeat center center;
    background-size: contain;
}
.card-text {
    margin-bottom: 11px;
    text-align: center;
    font-size: 16px;
    line-height: 26px;
    font-weight: 300;
}
.card-text2 {
    max-width: 800px;
    margin: -20px auto 20px;
}
.right-half-padding {
    padding-right: 25px;
}
.left-half-padding {
    padding-left: 25px;
}
.gift-title {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    color: #000000;
    white-space: pre-line;
    z-index: 2;
    font-style: normal;
    font-weight: 600;
    font-size: 19px;
    line-height: 120%;
    text-align: left;
    margin-top: 41px;
}
.gift-subtitle {
    font-family: "Roboto", Arial, Helvetica, sans-serif;
    color: #000000;
    white-space: pre-line;
    z-index: 2;
    position: relative;
    top: 10px;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 160%;
    text-align: left;
}
.home {
    font-size: 14px;
    background-color: #fff;
    color: #000;
}

.qr-popup.v-card {
    border-radius: 24px;
    height: 421px;
}
.qr-image {
    width: 320px;
    height: 300px;
    margin: 0 auto;
}
.qr-image.appStore {
    background: #ffffff url("../../assets/appstore-qr.svg") no-repeat center;
    background-size: 280px;
}
.qr-image.googlePlay {
    background: #ffffff url("../../assets/gplay-qr.svg") no-repeat center;
    background-size: 280px;
}
.qr-title {
    text-align: center;
    font-size: 22.5px;
    line-height: 31.5px;
    color: #090d0e;
    padding-top: 20px;
}
.qr-close {
    position: absolute;
    z-index: 1;
    top: 16px;
    right: 16px;
    width: 40px;
    height: 40px;
    border-radius: 55%;
    background: url("../../assets/icon-close.svg") no-repeat center;
}
.qr-close:hover {
    background-color: #f1e2c4;
    cursor: pointer;
}
.qr-popup .stores {
    margin: 0;
}
.qr-popup .appstore,
.qr-popup .gplay {
    width: 118px;
    height: 38px;
    margin: 0 auto;
    display: block;
}

.home ul {
    padding-left: 0;
}

.container {
    position: relative;
    max-width: 1170px;
    margin: 0 auto;
    padding: 0 15px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    z-index: 1;
}
.container1366 {
    position: relative;
    max-width: 1366px;
    margin: 0 auto;
    padding: 0 15px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    z-index: 1;
}

.video-background {
    height: calc(100% - 90px);
    width: 100%;
}

.hidden {
    display: none;
}

/* reset */

body,
div,
dl,
dt,
dd,
ul,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
code,
form,
fieldset,
input,
textarea,
p,
blockquote,
th,
td {
    margin: 0;
    padding: 0;
}

table {
    border-spacing: 0;
    border-collapse: collapse;
}

fieldset,
img,
abbr {
    border: 0;
}

address,
caption,
cite,
code,
dfn,
em,
strong,
th,
var {
    font-weight: normal;
    font-style: normal;
}

ul li {
    list-style: none;
}

caption,
th {
    text-align: left;
}

button {
    border: none;
    background: none;
}

button:hover {
    cursor: pointer;
}

a {
    text-decoration: none;
}

/* slogan section */

.slogan {
    height: 370px;
    position: relative;
}

.slogan-shadow {
    background: rgba(0, 0, 0, 0.35);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 370px;
}

.slogan-img {
    background: url("../../assets/home/home_banner.png") no-repeat center top;
    background-size: cover;
    width: 100%;
    height: 100%;
}
.slogan-img-collections {
    background: url("../../assets/home/collections.png") no-repeat center;
    background-size: cover;
}
.slogan-img-accessories {
    background: url("../../assets/home/accessories.png") no-repeat center;
    background-size: cover;
}
.slogan-img-live {
    background: url("../../assets/home/live.png") no-repeat center;
    background-size: cover;
}
.slogan-img-enprimeur {
    background: url("../../assets/home/enprimeur.png") no-repeat center 80%;
    background-size: cover;
}

.main-title {
    color: #ffffff;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-size: 48px;
    font-weight: bold;
    line-height: 49px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: 180px auto 0;
    text-transform: capitalize;
    text-align: center;
}

/* Start Gift section */

.gift {
    background: #efefef url("../../assets/home/banner.png") no-repeat center top;
    background-size: contain;
    height: 174px;
    width: 100%;
    margin-bottom: 35px;
    vertical-align: top;
}

.collections-gift-btn {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    display: block;
    width: 230px;
    min-height: 40px;
    line-height: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    background: var(--brand);
    color: #ffffff;
    text-decoration: none;
    text-align: center;
    border-radius: 4px;
    font-weight: 500;
    font-size: 16px;
    float: right;
}

.collections-gift-btn:hover {
    cursor: pointer;
}

/* End Gift section */

/* START Top Collections */
.home-title {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-size: 23px;
    line-height: 23px;
    font-weight: 700;
    color: #303030;
    margin-bottom: 18px;
    position: relative;
}

.show-all-btn {
    font-family: Roboto, sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 26px;
    float: right;
    text-decoration-line: underline;
    margin-right: 8px;
    color: #000000;
}

.home-collections-container {
    max-width: 1214px;
    margin: 0 auto;
}

/* END Top Collections */

.home-title-wine {
    text-align: center;
    font-weight: 400;
    font-size: 40px;
    line-height: 47px;
    margin: 24px auto 40px;
}
.home-title-live {
    margin-top: 50px;
}

.browse-market-btn {
    background: #cea94b;
    padding: 0 10px;
    width: 380px;
    height: 32px;
    line-height: 33px;
    border-radius: 4px;
    font-family: Roboto, sans-serif;
    font-weight: bold;
    font-size: 16px;
    color: #ffffff;
    display: block;
    margin: 0 auto 40px;
    text-align: center;
}
.show-contact-btn {
    background: #cea94b;
    padding: 0 16px;
    min-width: 120px;
    height: 32px;
    line-height: 33px;
    border-radius: 4px;
    font-family: Roboto, sans-serif;
    font-weight: bold;
    font-size: 16px;
    color: #ffffff;
    margin: 32px auto 0;
    text-align: center;
    display: inline-block;
}
.show-contact-btn:hover {
    cursor: pointer;
}
.contact-text {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 160%;
    color: #000000;
}
.contactus-headline {
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 25px;
    line-height: 120%;
    text-align: center;
    color: #303030;
    width: 300px;
    margin: 0 auto;
}
.home-more-collections {
    margin-bottom: 19px;
}
.home-title-coming-soon {
    text-align: center;
    margin: 150px auto;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-size: 25px;
    line-height: 30px;
    font-weight: 700;
}
.contact-wrapper {
    background: #f6f6f6;
    border-radius: 8px;
    padding: 27px 56px 32px 32px;
    margin: 32px auto 64px;
    width: 440px;
}
.contact-wrapper2 {
    background: #f6f6f6;
    border-radius: 8px;
    padding: 27px 38px 32px 32px;
    margin: 54px auto;
    max-width: 440px;
    text-align: center;
}
.submit-btn {
    background: #e1c376 !important;
    color: #fff !important;
    width: 200px;
    height: 40px !important;
    font-size: 18px;
    border-radius: 5px;
    text-transform: none;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    letter-spacing: 0;
    font-weight: lighter;
    box-shadow: none;
    margin: 15px auto 0;
    display: block;
}
.success-wrapper {
    text-align: center;
    background: url("../../assets/success_icon.png") no-repeat center 30px;
    padding: 140px 32px 0;
}
.success-info {
    color: #303030;
}
.done-btn {
    background: #e1c376 !important;
    color: #fff !important;
    margin-top: 30px;
    width: 200px;
    height: 40px !important;
    font-size: 18px;
    border-radius: 5px;
    text-transform: none;
}

.main-img {
    width: 100%;
    height: 100%;
    background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
    background-size: cover;
    background-repeat: no-repeat;
    background-position: right center;
}
.home-banner-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.section1-left,
.section1-right {
    display: inline-block;
    width: calc((100% - 30px) / 2);
    vertical-align: top;
    height: 100%;
}
.section1-left {
    margin-right: 24px;
}
.section1-title {
    margin-top: 24px;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 36px;
    line-height: 44px;
    color: #FFFFFF;
    margin-bottom: 16px;
}
.section1-subtitle {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    line-height: 27px;
    color: #FFFFFF;
    margin-bottom: 32px;
}
@media(min-width: 1280px) {
    .section1-title {
        min-height: 176px;
    }
    .section1-subtitle {
        min-height: 81px;
    }
}
.home-section1-img {
    width: 100%;
    height: 100%;
    position: relative;
    text-align: right;
    background-size: contain;
    background-position: right center;
}
.home-section1-img img {
    background-size: contain;
    width: 100%;
    height: 100%;
    max-height: 360px;
    max-width: 178px;
    margin-top: 23px;
}
.main-img-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.section1-container {
    height: 100%;
    padding: 37px 200px 28px;
}
.home-section1-btn1 {
    padding: 8px 16px;
    height: 36px;
    background: #ffffff;
    border-radius: 8px;
    color: #004F7F;
    display: inline-block;
    vertical-align: top;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    box-sizing: border-box;
}
.home-section1-btn2 {
    display: inline-block;
    vertical-align: top;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    color: #ffffff;
    border: 2px solid #ffffff;
    background: rgba(255, 255, 255, 0.16);
    border-radius: 8px;
    padding: 8px 16px;
    height: 36px;
    margin-left: 12px;
    box-sizing: border-box;
}
.home-section2 {
    height: 430px;
    padding: 52px 0 45px;
}
.home-section3 {
    height: 340px;
    margin-bottom: 91px;
}
.home-section4 {
    height: 476px;
    background: #f7f7f7;
    padding: 80px 0 60px;
}
.horizontal-tab {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    text-transform: uppercase;
    color: #004F7F;
    letter-spacing: normal;
}
.vtab-wrapper {
    margin-top: 20px;
    height: 281px;
    width: 100%;
}
.home-section4-text {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #002840;
    margin-top: 80px;
    margin-bottom: 24px;
}
.home-section4-img,
.home-section4-img1,
.home-section4-img2 {
    width: 100%;
    height: 100%;
    position: relative;
}

.home-section4-img {
    background: url('../../assets/home/home_collections.svg') no-repeat center;
    background-size: contain;
}
html[lang="de"] .home-section4-img {
    background: url('../../assets/home/home_collections_de.png') no-repeat center;
    background-size: contain;
}
html[lang="it"] .home-section4-img {
    background: url('../../assets/home/home_collections_it.png') no-repeat center;
    background-size: contain;
}
html[lang="fr"] .home-section4-img {
    background: url('../../assets/home/home_collections_fr.png') no-repeat center;
    background-size: contain;
}
html[lang="ru"] .home-section4-img {
    background: url('../../assets/home/home_collections_ru.png') no-repeat center;
    background-size: contain;
}
.home-section4-img1 {
    background: url('../../assets/home/home_live_market.png') no-repeat center;
    background-size: contain;
}
.home-section4-img2 {
    background: url('../../assets/home/home_en_primeur.png') no-repeat left center;
    background-size: contain;
}
html[lang="de"] .home-section4-img2 {
    background: url('../../assets/home/home_en_primeur_de.png') no-repeat center;
    background-size: contain;
}
html[lang="it"] .home-section4-img2 {
    background: url('../../assets/home/home_en_primeur_it.png') no-repeat center;
    background-size: contain;
}
html[lang="fr"] .home-section4-img2 {
    background: url('../../assets/home/home_en_primeur_fr.png') no-repeat center;
    background-size: contain;
}
html[lang="ru"] .home-section4-img2 {
    background: url('../../assets/home/home_en_primeur.png') no-repeat center;
    background-size: contain;
}

.home-section5 {
    height: 576px;
    padding: 80px 0;
    background: linear-gradient(88.98deg, #003758 0%, #004B79 52.08%, #00629D 100%);
}
.home-section5-title {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    text-align: center;
    color: #FFFFFF;
}

.home-section6 {
    min-height: 629px;
    padding: 80px 0;
}
.home-section6-item-wrapper {
    vertical-align: top;
}
.home-section6-item {
    display: inline-block;
    width: calc((100% - 56px) / 3);
    padding-left: 53px;
    position: relative;
    vertical-align: top;
    margin-bottom: 42px;
}
.home-section6-item-wrapper > .home-section6-item:nth-child(1),
.home-section6-item-wrapper > .home-section6-item:nth-child(2) {
    margin-right: 24px;
}
.home-section6-title {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #002840;
    margin-bottom: 8px;
}
.home-section6-subtitle {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #002840;
}
.home-section6-img {
    width: 40px;
    height: 40px;
    position: absolute;
    top: 0;
    left: 0;
}
.home-section7 {
    min-height: 453px;
    background: #f7f7f7;
    padding: 80px 0;
}
.journey-item {
    display: inline-block;
    width: calc((100% - 294px) / 4);
    text-align: center;
    vertical-align: top;
    margin-bottom: 40px;
}
.journey-num-border {
    width: 56px;
    height: 56px;
    border: 4px solid rgba(0, 0, 0, 0.12);
    border-radius: 50%;
    text-align: center;
    margin: 0 auto 8px;
}
.journey-item1 .journey-num {
    background: #E5CB87;
    border-radius: 50%;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 48px;
    text-align: center;
    color: #FFFFFF;
}
.journey-item2 .journey-num {
    background: #C7AC69;
    border-radius: 50%;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 48px;
    text-align: center;
    color: #FFFFFF;
}
.journey-item3 .journey-num {
    background: #907D4C;
    border-radius: 50%;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 48px;
    text-align: center;
    color: #FFFFFF;
}
.journey-item4 .journey-num {
    background: #5A4E30;
    border-radius: 50%;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 48px;
    text-align: center;
    color: #FFFFFF;
}
.journey-title {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: #002840;
}
.journey-separator {
    display: inline-block;
    width: 90px;
    height: 6px;
    vertical-align: top;
    margin-top: 26px;
}
.journey-separator1 {
    background: url("../../assets/home/arrow1.png") no-repeat center;
}
.journey-separator2 {
    background: url("../../assets/home/arrow2.png") no-repeat center;
}
.journey-separator3 {
    background: url("../../assets/home/arrow3.png") no-repeat center;
}
.home-section8 {
    height: 585px;
    padding: 80px 0;
}
.home-section8-title {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    color: #000000;
}
.home-section9 {
    height: 693px;
    background: #f7f7f7;
    padding: 80px 0;
}
.home-section9-title {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    text-align: center;
    color: #002840;
}
.home-section9-border {
    width: 64px;
    height: 4px;
    background: #ECD9A7;
    margin: 24px auto 40px;
}
.home-section10 {
    min-height: 613px;
    background: linear-gradient(88.98deg, #003758 0%, #004B79 52.08%, #00629D 100%);
}
.home-section2 .container1366,
.home-section3 .container1366,
.home-section4 .container1366,
.home-section7 .container1366,
.home-section10 .container1366 {
    height: 100%;
}
.padding200 {
    padding: 0 200px;
}
.home-section10 .container1366 {
    padding: 80px 200px 40px;
}
.home-section10-title {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    text-align: center;
    color: #FFFFFF;
    margin-bottom: 12px;
}
.home-section10-subtitle {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: #FFFFFF;
    margin-bottom: 24px;
}
.center {
    text-align: center;
}
.home-left-50,
.home-right-50 {
    display: inline-block;
    width: calc((100% - 24px) / 2);
    height: 100%;
    vertical-align: top;
}
.home-left-50 {
    margin-right: 20px;
}
.home-section2-img,
.home-section3-img {
    width: 100%;
    height: 100%;
}
.home-section2-img img,
.home-section3-img img {
    background-size: contain;
    width: 100%;
    height: 100%;
    max-width: 463px;
    max-height: 323px;
}
.home-section10-img img {
    background-size: contain;
    width: 100%;
    height: 100%;
}
.home-section2-title {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    align-items: center;
    color: #002840;
    margin-bottom: 8px;
    margin-top: 20px;
}
.home-section2-title2 {
    margin-top: 39px;
}
.home-section2-subtitle {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #002840;
    margin-bottom: 24px;
}
.home-section2-bullet {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #002840;
    padding-left: 17px;
    background: url("../../assets/home/bullet-point.svg") no-repeat left center;
}
.home-section2-bullets {
    margin-bottom: 24px;
}
.home-section2-btn1 {
    padding: 8px 16px;
    height: 36px;
    background: #004F7F;
    border-radius: 8px;
    color: #ffffff;
    display: inline-block;
    vertical-align: top;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
}
.home-section2-btn2 {
    display: inline-block;
    vertical-align: top;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    color: #004F7F;
    border: 2px solid #004F7F;
    border-radius: 8px;
    padding: 8px 16px;
    height: 36px;
    margin-left: 12px;
}
.home-section2-btn1.btn-white {
    background: #ffffff;
    color: #004F7F;
}
.home-section2-btn1.btn-white:hover {
    cursor: pointer;
}
.home-section2-btn2.border-white {
    border-color: white;
    color: white;
}
.home-section10-right,
.home-section10-left {
    display: inline-block;
    width: calc(50% - 2px);
    vertical-align: top;
    height: 341px;
}
.home-section10-btn-wrapper {
    margin-bottom: 40px;
}
.home-section10-title2 {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    color: #FFFFFF;
    margin-top: 42px;
    margin-bottom: 40px;
}
.home-section10-qr-wrapper {
    margin-bottom: 16px;
}
.home-section10-qr-wrapper svg {
    margin-right: 32px;
    border-radius: 8px;
}
.home-section10-store-wrapper svg {
    margin-right: 39px;
}

.theme--light.v-btn.v-btn--has-bg.login-submit {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 16px;
    gap: 8px;
    width: 382px;
    height: 40px;
    background: #004F7F;
    border-radius: 8px;
    margin-top: 24px;
}
.additional-info {
    text-align: center;
    margin: 32px auto;
}


@media (max-width: 767px) {
    .login-success h2 {
        font-size: 20px;
        line-height: 24px;
    }
    .wine-guide-left {
        width: 100%;
        margin-right: 0;
        display: block;
    }
    .wine-guide-mobile {
        display: block;
        width: 100%;
        height: 200px;
        border-radius: 16px;
        background: #ffffff url('../../assets/map.png') no-repeat center top;
        background-size: contain;
        margin-bottom: 16px;
    }
    .qr-popup.v-card.zoho-popup {
        width: 100%;
        height: auto;
    }
    .guide-content {
        background: #ffffff;
    }
    .guide-reg-wrapper,
    .theme--light.v-btn.v-btn--has-bg.login-submit {
        width: 100%;
    }
    .mobile-back {
        display: block;
        height: 177px;
        margin-top: 32px;
        margin-bottom: 32px;
        width: 100%;
        background: url("../../assets/how/mobile_back.png") no-repeat right bottom;
    }
    .guide-title {
        width: calc(100% - 30px);
    }
    .main-img-bg {
        object-fit: cover;
    }
    .home-section1-img img {
        max-height: 267.5px;
        max-width: 132px;
        margin-top: 36px
    }
    .gift {
        height: 215px;
        background-size: 190%;
    }
    .home-title {
        font-size: 17px;
        line-height: 17px;
        font-weight: 700;
    }
    .show-all-btn {
        font-size: 13px;
        line-height: 20px;
    }
    .browse-market-btn {
        width: 100%;
        text-align: center;
        font-weight: normal;
        font-size: 14px;
    }
    .contact-wrapper {
        padding: 25px;
        width: 100%;
    }
    .collections-h1 {
        font-size: 30px;
    }
    .gift-title {
        text-align: center;
        margin-top: 0;
        padding-top: 23px;
    }
    .gift-subtitle {
        text-align: center;
    }
    .collections-gift-btn {
        margin: 50px auto 0;
        float: none;
    }

    .carousel-wrapper-new {
        height: 400px;
    }
    .section1-container {
        padding: 16px;
        text-align: center;
    }
    .section1-right {
        display: none;
    }
    .section1-left {
        width: 290px;
        margin: 0 auto;
        display: block;
    }
    .section1-left .home-section2-btn-wrapper {
        text-align: center;
    }
    .section1-title {
        font-size: 18px;
        line-height: 22px;
        margin-bottom: 10px;
    }
    .section1-subtitle {
        font-size: 16px;
        line-height: 20px;
    }
    .padding200 {
        padding: 0 16px;
    }
    .home-section2,
    .home-section3 {
        height: auto;
        padding: 16px 0;
    }
    .home-section2 .home-section2-btn-wrapper .home-section2-btn1,
    .home-section2 .home-section2-btn-wrapper .home-section2-btn2,
    .home-section3 .home-section2-btn-wrapper .home-section2-btn1,
    .home-section4 .home-section2-btn-wrapper .home-section2-btn1,
    .home-section7 .home-section2-btn-wrapper .home-section2-btn1,
    .home-section7 .home-section2-btn-wrapper .home-section2-btn2 {
        display: block;
        width: 100%;
        margin: 0 auto;
        text-align: center;
    }
    .home-section2 .home-section2-btn-wrapper .home-section2-btn2,
    .home-section7 .home-section2-btn-wrapper .home-section2-btn2 {
        margin-top: 16px;
    }
    .home-left-50 {
        margin-right: 0;
        display: block;
        height: auto;
        width: 100%;
    }
    .home-right-50 {
        width: 100%;
        display: block;
    }
    .home-section3 {
        margin: 16px 0;
    }
    .home-section4 {
        height: auto;
        padding: 16px 0;
    }
    .vtab-wrapper {
        height: 520px;
    }
    .vtab-wrapper .home-left-50 {
        height: auto;
    }
    .home-section4-img,
    .home-section4-img1,
    .home-section4-img2 {
        height: 320px;
    }
    .home-section4-text {
        margin-top: 32px;
    }
    .home-section6 {
        padding: 32px 0 0;
    }
    .home-section6-item {
        display: block;
        width: 100%;
        padding-left: 53px;
        margin-bottom: 42px;
    }
    .home-section6-item-wrapper > .home-section6-item:nth-child(1),
    .home-section6-item-wrapper > .home-section6-item:nth-child(2) {
        margin-right: 0;
    }
    .home-section7 {
        min-height: auto;
        padding: 32px 0;
    }
    .journey-item {
        display: block;
        width: 100%;
        margin-bottom: 40px;
    }
    .journey-separator {
        display: block;
        width: 90px;
        height: 106px;
        vertical-align: top;
        margin: 0 auto;
        transform: rotate(90deg);
    }
    .journey-item.journey-item2,
    .journey-item.journey-item3,
    .journey-item.journey-item4 {
        margin-top: 40px;
    }
    .home-section8 {
        min-height: auto;
        height: auto;
        padding: 32px 0;
    }
    .home-section10 {
        min-height: auto;
        background: transparent;
    }
    .home-section10 .container1366 {
        padding: 32px 0 0;
    }
    .home-section10-title,
    .home-section10-subtitle {
        color: black;
    }
    .home-section10-btn-wrapper {
        padding-right: 12px;
        padding-left: 12px;
    }
    .home-section10 .home-section2-btn1.btn-white {
        background: #004F7F;
        color: #ffffff;
    }
    .home-section10 .home-section2-btn2.border-white {
        color: #004F7F;
        border-color: #004F7F;
    }
    .home-section10-title2 {
        font-weight: 700;
        font-size: 24px;
        line-height: 29px;
        margin-top: 0;
    }
    .home-section10-left {
        display: block;
        width: 100%;
        vertical-align: top;
        padding-right: 12px;
        padding-left: 12px;
        padding-top: 24px;
        height: auto;
        background: linear-gradient(88.98deg, #003758 0%, #004B79 52.08%, #00629D 100%);
    }
    .home-section10-qr-wrapper,
    .home-section10-store-wrapper {
        display: flex;
        justify-content: space-between;
    }
    .home-section10-qr-wrapper svg,
    .home-section10-store-wrapper svg {
        margin-right: 0;
    }
    .home-section10-qr-wrapper > svg,
    .home-section10-store-wrapper > svg,
    .home-section10-qr-wrapper > a,
    .home-section10-store-wrapper > a {
        width: calc(100% / 2);
    }
    .home-section10-qr-wrapper a svg,
    .home-section10-store-wrapper a svg {
        margin: 0 auto 16px;
        display: block;
    }
    .home-section10-right {
        display: block;
        width: 100%;
        padding: 24px 12px;
        background: linear-gradient(88.98deg, #003758 0%, #004B79 52.08%, #00629D 100%);
    }
    .home-section5 {
        padding: 32px 0;
        height: auto;
    }
    .home-section5 .home-section1-btn1 {
        position: relative;
        top: -10px;
    }
    .home-section3 .home-left-50 {
        height: auto;
    }
    .home a.news__button,
    .home .home-section2-btn2.border-white,
    .home .home-section2-btn1.btn-white {
        display: block;
        width: 100%;
        margin-left: 0;
        text-align: center;
    }
    .news-section9 {
        background: #f7f7f7;
        padding-bottom: 0;
        height: auto;
    }
}
</style>

<style>
.news-articles-carousel .vueperslides__bullet .default {
    width: 6px;
    height: 6px;
    border: 0;
    box-shadow: none;
    background: rgba(0, 0, 0, 0.16);
}
.news-articles-carousel .vueperslides__bullet--active .default {
    background: #E2C477;
    width: 8px;
    height: 8px;
}
.news-wrapper .vueperslide__content-wrapper.blog-img-layer {
    box-shadow: 0 4px 32px rgba(117, 102, 62, 0.32);
    border-radius: 16px;
}
.news-wrapper .vueperslides__track-inner {
    padding: 0 15px;
}
.news-wrapper .news-carousel-text-wrapper {
    width: 100%;
    height: calc(100% - 240px);
    padding: 16px 20px;
    text-align: left;
}
.news__title {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    color: rgba(0, 0, 0, 0.88);
    height: 22px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
div.news__content {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.88);
    margin-top: 8px;
    margin-bottom: 24px;
}
a.news__button {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 8px 16px;
    gap: 8px;
    width: 142px;
    height: 36px;
    background: #004F7F;
    border-radius: 8px;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    color: #ffffff;
}
.news-articles-carousel.vueperslides {
    max-width: 100%;
}
.news-articles-carousel:not(.vueperslides--slide-multiple) .vueperslide {
    transform: scale(.65);
    transition: .3s ease-in-out;
    border-radius: 16px;
    background-size: 260px;
    background-position-y: top;
}

.news-articles-carousel:not(.vueperslides--slide-multiple) .vueperslide--active {
    transform: scale(0.92);
    box-shadow: none;
    z-index: 1
}
.home-tabs .v-tabs-slider {
    background-color: #004F7F;
}
.home-tabs .v-tabs-slider-wrapper {
    height: 4px !important;
}
.home-tabs.theme--light.v-tabs > .v-tabs-bar,
.home-tabs .theme--light.v-tabs-items {
    background-color: #f7f7f7;
}
.contactus-dialog {
    background: #ffffff;
}
.theme--light.v-card.contact-card {
    box-shadow: none;
    padding-top: 31px;
    transition: none;
    background: #fff;
}
.home-tab-container .theme--light.v-tabs .v-tabs-bar {
    height: 55px;
    background-color: var(--semi-white);
    max-width: 100%;
    /*margin: 0 auto;*/
}

.vueperslides__arrow--prev {
    background: url("../../assets/press_left.png") no-repeat center;
    background-size: contain;
    width: 38px;
    height: 37px;
}

.vueperslides__arrow--next {
    background: url("../../assets/press_right.png") no-repeat center;
    background-size: contain;
    width: 38px;
    height: 37px;
}
.vueperslides__arrow--prev svg,
.vueperslides__arrow--next svg {
    display: none;
}
.v-slide-group__wrapper {
    max-width: 640px;
    margin: 0 auto;
}
.trading-desk .v-slide-group__wrapper {
    margin: 0;
}
.home-tab-container .v-slide-group__content {
    justify-content: center;
}
.home-tab-container .v-tab {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    color: #000 !important;
    font-size: 16px;
    text-transform: none;
    line-height: 23px;
    letter-spacing: inherit;
}
.home-tab-container .v-tabs-slider-wrapper {
    height: 6px !important;
    color: #e2c477 !important;
    caret-color: #e2c477 !important;
}

.swiper-container {
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 1;
    height: 300px;
    width: 100%;
}
.show-mobile .swiper-container {
    height: 360px;
}
.people-notice-wrapper .swiper-container {
    height: 430px;
    margin-bottom: 50px;
}
.home-section8-wrapper .swiper-container {
    height: 332px !important;
}
.swiper-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    transition-property: -webkit-transform;
    transition-property: transform;
    transition-property: transform, -webkit-transform;
    box-sizing: content-box;
}

.swiper-container-no-flexbox .swiper-slide {
    float: left;
}

.swiper-container-vertical > .swiper-wrapper {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
}

.swiper-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    transition-property: -webkit-transform;
    transition-property: transform;
    transition-property: transform, -webkit-transform;
    box-sizing: content-box;
}

.swiper-container-android .swiper-slide,
.swiper-wrapper {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
}

.swiper-container-multirow > .swiper-wrapper {
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
}

.swiper-container-free-mode > .swiper-wrapper {
    transition-timing-function: ease-out;
    margin: 0 auto;
}

.swiper-slide {
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 100%;
    height: 100%;
    position: relative;
    transition-property: -webkit-transform;
    transition-property: transform;
    transition-property: transform, -webkit-transform;
}

.swiper-slide.swiper-slide-active .testimonial-item {
    border-right: 1px solid #f0f0f0;
    padding-left: 0;
    padding-right: 45px;
}

.show-mobile .swiper-slide.swiper-slide-active .testimonial-item {
    border-right: 0;
    padding-right: 0;
}

.swiper-invisible-blank-slide {
    visibility: hidden;
}

.swiper-container-autoheight,
.swiper-container-autoheight .swiper-slide {
    height: auto;
}

.swiper-container-autoheight .swiper-wrapper {
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    transition-property: height, -webkit-transform;
    transition-property: transform, height;
    transition-property: transform, height, -webkit-transform;
}

.swiper-container-3d {
    -webkit-perspective: 1200px;
    perspective: 1200px;
}

.swiper-container-3d .swiper-cube-shadow,
.swiper-container-3d .swiper-slide,
.swiper-container-3d .swiper-slide-shadow-bottom,
.swiper-container-3d .swiper-slide-shadow-left,
.swiper-container-3d .swiper-slide-shadow-right,
.swiper-container-3d .swiper-slide-shadow-top,
.swiper-container-3d .swiper-wrapper {
    -webkit-transform-style: preserve-3d;
    transform-style: preserve-3d;
}

.swiper-container-3d .swiper-slide-shadow-bottom,
.swiper-container-3d .swiper-slide-shadow-left,
.swiper-container-3d .swiper-slide-shadow-right,
.swiper-container-3d .swiper-slide-shadow-top {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 10;
}

.swiper-container-3d .swiper-slide-shadow-left {
    background-image: linear-gradient(270deg, rgba(0, 0, 0, 0.5), transparent);
}

.swiper-container-3d .swiper-slide-shadow-right {
    background-image: linear-gradient(90deg, rgba(0, 0, 0, 0.5), transparent);
}

.swiper-container-3d .swiper-slide-shadow-top {
    background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.5), transparent);
}

.swiper-container-3d .swiper-slide-shadow-bottom {
    background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.5), transparent);
}

.swiper-container-wp8-horizontal,
.swiper-container-wp8-horizontal > .swiper-wrapper {
    -ms-touch-action: pan-y;
    touch-action: pan-y;
}

.swiper-container-wp8-vertical,
.swiper-container-wp8-vertical > .swiper-wrapper {
    -ms-touch-action: pan-x;
    touch-action: pan-x;
}

.swiper-button-next,
.swiper-button-prev {
    position: absolute;
    top: 50%;
    width: 27px;
    height: 44px;
    margin-top: -22px;
    z-index: 10;
    cursor: pointer;
    background-size: 27px 44px;
    background-position: 50%;
    background-repeat: no-repeat;
}
.testimonials-button-next,
.testimonials-button-prev {
    position: absolute;
    top: 120px;
    width: 38px;
    height: 36px;
    z-index: 10;
    cursor: pointer;
}
.calc-button-next,
.calc-button-prev {
    position: absolute;
    top: 120px;
    width: 38px;
    height: 36px;
    z-index: 10;
    cursor: pointer;
}

.swiper-button-next.swiper-button-disabled,
.swiper-button-prev.swiper-button-disabled,
.testimonials-button-next.swiper-button-disabled,
.testimonials-button-prev.swiper-button-disabled,
.calc-button-next.swiper-button-disabled,
.calc-button-prev.swiper-button-disabled {
    opacity: 0.35;
    cursor: auto;
    pointer-events: none;
}

.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z' fill='%23007aff'/%3E%3C/svg%3E");
    left: 50px;
    right: auto;
}
.testimonials-button-prev,
.swiper-container-rtl .testimonials-button-next {
    background: url("../../assets/home/testimonials_left.png") no-repeat center;
    background-size: contain;
    left: 0;
    right: auto;
}
.calc-button-prev,
.swiper-container-rtl .calc-button-next {
    background: #ffffff url("../../assets/home/calc_left.png") no-repeat center;
    background-size: contain;
    left: 0;
    right: auto;
}

.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z' fill='%23007aff'/%3E%3C/svg%3E");
    right: 50px;
    left: auto;
}
.testimonials-button-next,
.swiper-container-rtl .testimonials-button-prev {
    background: url("../../assets/home/testimonials_right.png") no-repeat center;
    background-size: contain;
    right: 0;
    left: auto;
}
.calc-button-next,
.swiper-container-rtl .calc-button-prev {
    background: #ffffff url("../../assets/home/calc_right.png") no-repeat center;
    background-size: contain;
    right: 0;
    left: auto;
}

.swiper-button-prev.swiper-button-white,
.swiper-container-rtl .swiper-button-next.swiper-button-white {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z' fill='%23fff'/%3E%3C/svg%3E");
}

.swiper-button-next.swiper-button-white,
.swiper-container-rtl .swiper-button-prev.swiper-button-white {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z' fill='%23fff'/%3E%3C/svg%3E");
}

.swiper-button-prev.swiper-button-black,
.swiper-container-rtl .swiper-button-next.swiper-button-black {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z'/%3E%3C/svg%3E");
}

.swiper-button-next.swiper-button-black,
.swiper-container-rtl .swiper-button-prev.swiper-button-black {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z'/%3E%3C/svg%3E");
}

.swiper-pagination {
    position: absolute;
    text-align: center;
    transition: opacity 0.3s;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    z-index: 10;
}

.swiper-pagination.swiper-pagination-hidden {
    opacity: 0;
}

.swiper-container-horizontal > .swiper-pagination-bullets,
.swiper-pagination-custom,
.swiper-pagination-fraction {
    bottom: 10px;
    left: 0;
    width: 100%;
}
.home-section8-wrapper .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 0
}
.carousel-wrapper {
    height: 480px;
    position: relative;
}
.carousel-wrapper-new {
    height: 480px;
    position: relative;
    top: 79px;
    margin-bottom: 80px;
}

@media (max-width: 767px) {
    .swiper-container-horizontal > .swiper-pagination-bullets,
    .swiper-pagination-custom,
    .swiper-pagination-fraction {
        bottom: 0;
    }
    .home-section5 .swiper-container {
        height: auto !important;
    }
    .news__title {
        font-size: 16px;
        line-height: 20px;
    }
    .news__content {
        font-size: 14px;
        height: 35px;
        overflow: hidden;
        text-overflow: ellipsis;
        position: relative;
    }
    .news-wrapper .vueperslides__track-inner {
        padding: 0 !important;
    }
    .news-articles-carousel.vueperslides {
        padding-bottom: 0 !important;
        height: auto !important;
    }
    .vueperslides--fixed-height .vueperslide {
        height: 410px;
        padding: 0;
    }

    .vueperslides--fixed-height .vueperslides__inner,
    .vueperslides--fixed-height .vueperslides__parallax-wrapper {
        height: 470px;
        padding-bottom: 60px;
    }
    .vueperslides__bullets:not(.vueperslides__bullets--outside) {
        bottom: 10px;
    }

    .vueperslides__arrow--prev {
        left: 15px;
        width: 28px;
        height: 27px;
        top: 430px;
    }
    .vueperslides__arrow--next {
        right: 15px;
        width: 28px;
        height: 27px;
        top: 430px;
    }
    .slide-bg {
        background-position: center left;
    }
}

.swiper-pagination-bullets-dynamic {
    overflow: hidden;
    font-size: 0;
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
    -webkit-transform: scale(0.33);
    transform: scale(0.33);
    position: relative;
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {
    -webkit-transform: scale(1);
    transform: scale(1);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {
    -webkit-transform: scale(0.66);
    transform: scale(0.66);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {
    -webkit-transform: scale(0.33);
    transform: scale(0.33);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {
    -webkit-transform: scale(0.66);
    transform: scale(0.66);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {
    -webkit-transform: scale(0.33);
    transform: scale(0.33);
}

.swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    display: inline-block;
    border-radius: 100%;
    background: #000;
    opacity: 0.2;
}

.home-section5 .swiper-pagination-bullet,
.home-section8-wrapper .swiper-pagination-bullet {
    width: 6px;
    height: 6px;
}
.home-section5 .swiper-pagination-bullet-active,
.home-section8-wrapper .swiper-pagination-bullet-active {
    opacity: 1;
    background: var(--brand);
    width: 8px;
    height: 8px;
    position: relative;
    top: 1px;
}

button.swiper-pagination-bullet {
    border: none;
    margin: 0;
    padding: 0;
    box-shadow: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

.swiper-pagination-clickable .swiper-pagination-bullet {
    cursor: pointer;
}

.swiper-pagination-bullet-active {
    opacity: 1;
    background: #007aff;
}

.swiper-container-vertical > .swiper-pagination-bullets {
    right: 10px;
    top: 50%;
    -webkit-transform: translate3d(0, -50%, 0);
    transform: translate3d(0, -50%, 0);
}

.swiper-container-vertical
> .swiper-pagination-bullets
.swiper-pagination-bullet {
    margin: 6px 0;
    display: block;
}

.swiper-container-vertical
> .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    width: 8px;
}

.swiper-container-vertical
> .swiper-pagination-bullets.swiper-pagination-bullets-dynamic
.swiper-pagination-bullet {
    display: inline-block;
    transition: top 0.2s, -webkit-transform 0.2s;
    transition: transform 0.2s, top 0.2s;
    transition: transform 0.2s, top 0.2s, -webkit-transform 0.2s;
}

.swiper-container-horizontal
> .swiper-pagination-bullets
.swiper-pagination-bullet {
    margin: 0 4px;
}

.swiper-container-horizontal
> .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    white-space: nowrap;
}

.swiper-container-horizontal
> .swiper-pagination-bullets.swiper-pagination-bullets-dynamic
.swiper-pagination-bullet {
    transition: left 0.2s, -webkit-transform 0.2s;
    transition: transform 0.2s, left 0.2s;
    transition: transform 0.2s, left 0.2s, -webkit-transform 0.2s;
}

.swiper-container-horizontal.swiper-container-rtl
> .swiper-pagination-bullets-dynamic
.swiper-pagination-bullet {
    transition: right 0.2s, -webkit-transform 0.2s;
    transition: transform 0.2s, right 0.2s;
    transition: transform 0.2s, right 0.2s, -webkit-transform 0.2s;
}

.swiper-pagination-progressbar {
    background: rgba(0, 0, 0, 0.25);
    position: absolute;
}

.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
    background: #007aff;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    -webkit-transform: scale(0);
    transform: scale(0);
    -webkit-transform-origin: left top;
    transform-origin: left top;
}

.swiper-container-rtl
.swiper-pagination-progressbar
.swiper-pagination-progressbar-fill {
    -webkit-transform-origin: right top;
    transform-origin: right top;
}

.swiper-container-horizontal > .swiper-pagination-progressbar {
    width: 100%;
    height: 4px;
    left: 0;
    top: 0;
}

.swiper-container-vertical > .swiper-pagination-progressbar {
    width: 4px;
    height: 100%;
    left: 0;
    top: 0;
}

.swiper-pagination-white .swiper-pagination-bullet-active {
    background: #fff;
}

.swiper-pagination-progressbar.swiper-pagination-white {
    background: hsla(0, 0%, 100%, 0.25);
}

.swiper-pagination-progressbar.swiper-pagination-white
.swiper-pagination-progressbar-fill {
    background: #fff;
}

.swiper-pagination-black .swiper-pagination-bullet-active {
    background: #000;
}

.swiper-pagination-progressbar.swiper-pagination-black {
    background: rgba(0, 0, 0, 0.25);
}

.swiper-pagination-progressbar.swiper-pagination-black
.swiper-pagination-progressbar-fill {
    background: #000;
}

.swiper-scrollbar {
    border-radius: 10px;
    position: relative;
    -ms-touch-action: none;
    background: rgba(0, 0, 0, 0.1);
}

.swiper-container-horizontal > .swiper-scrollbar {
    position: absolute;
    left: 1%;
    bottom: 3px;
    z-index: 50;
    height: 5px;
    width: 98%;
}

.swiper-container-vertical > .swiper-scrollbar {
    position: absolute;
    right: 3px;
    top: 1%;
    z-index: 50;
    width: 5px;
    height: 98%;
}

.swiper-scrollbar-drag {
    height: 100%;
    width: 100%;
    position: relative;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    left: 0;
    top: 0;
}

.swiper-scrollbar-cursor-drag {
    cursor: move;
}

.swiper-zoom-container {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    text-align: center;
}

.swiper-zoom-container > canvas,
.swiper-zoom-container > img,
.swiper-zoom-container > svg {
    max-width: 100%;
    max-height: 100%;
    -o-object-fit: contain;
    object-fit: contain;
}

.swiper-slide-zoomed {
    cursor: move;
}

.swiper-lazy-preloader {
    width: 42px;
    height: 42px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -21px;
    margin-top: -21px;
    z-index: 10;
    -webkit-transform-origin: 50%;
    transform-origin: 50%;
    -webkit-animation: swiper-preloader-spin 1s steps(12) infinite;
    animation: swiper-preloader-spin 1s steps(12) infinite;
}

.swiper-lazy-preloader:after {
    display: block;
    content: "";
    width: 100%;
    height: 100%;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' stroke='%236c6c6c' stroke-width='11' stroke-linecap='round' d='M60 7v20'/%3E%3C/defs%3E%3Cuse xlink:href='%23a' opacity='.27'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(30 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(60 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(90 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(120 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(150 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.37' transform='rotate(180 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.46' transform='rotate(210 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.56' transform='rotate(240 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.66' transform='rotate(270 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.75' transform='rotate(300 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.85' transform='rotate(330 60 60)'/%3E%3C/svg%3E");
    background-position: 50%;
    background-size: 100%;
    background-repeat: no-repeat;
}

.swiper-lazy-preloader-white:after {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' stroke='%23fff' stroke-width='11' stroke-linecap='round' d='M60 7v20'/%3E%3C/defs%3E%3Cuse xlink:href='%23a' opacity='.27'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(30 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(60 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(90 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(120 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(150 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.37' transform='rotate(180 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.46' transform='rotate(210 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.56' transform='rotate(240 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.66' transform='rotate(270 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.75' transform='rotate(300 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.85' transform='rotate(330 60 60)'/%3E%3C/svg%3E");
}

@-webkit-keyframes swiper-preloader-spin {
    to {
        -webkit-transform: rotate(1turn);
        transform: rotate(1turn);
    }
}

@keyframes swiper-preloader-spin {
    to {
        -webkit-transform: rotate(1turn);
        transform: rotate(1turn);
    }
}

.swiper-container .swiper-notification {
    position: absolute;
    left: 0;
    top: 0;
    pointer-events: none;
    opacity: 0;
    z-index: -1000;
}

.swiper-container-fade.swiper-container-free-mode .swiper-slide {
    transition-timing-function: ease-out;
}

.swiper-container-fade .swiper-slide {
    pointer-events: none;
    transition-property: opacity;
}

.swiper-container-fade .swiper-slide .swiper-slide {
    pointer-events: none;
}

.swiper-container-fade .swiper-slide-active,
.swiper-container-fade .swiper-slide-active .swiper-slide-active {
    pointer-events: auto;
}

.swiper-container-cube {
    overflow: visible;
}

.swiper-container-cube .swiper-slide {
    pointer-events: none;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    z-index: 1;
    visibility: hidden;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    width: 100%;
    height: 100%;
}

.swiper-container-cube .swiper-slide .swiper-slide {
    pointer-events: none;
}

.swiper-container-cube.swiper-container-rtl .swiper-slide {
    -webkit-transform-origin: 100% 0;
    transform-origin: 100% 0;
}

.swiper-container-cube .swiper-slide-active,
.swiper-container-cube .swiper-slide-active .swiper-slide-active {
    pointer-events: auto;
}

.swiper-container-cube .swiper-slide-active,
.swiper-container-cube .swiper-slide-next,
.swiper-container-cube .swiper-slide-next + .swiper-slide,
.swiper-container-cube .swiper-slide-prev {
    pointer-events: auto;
    visibility: visible;
}

.swiper-container-cube .swiper-slide-shadow-bottom,
.swiper-container-cube .swiper-slide-shadow-left,
.swiper-container-cube .swiper-slide-shadow-right,
.swiper-container-cube .swiper-slide-shadow-top {
    z-index: 0;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
}

.swiper-container-cube .swiper-cube-shadow {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.6;
    -webkit-filter: blur(50px);
    filter: blur(50px);
    z-index: 0;
}

.swiper-container-flip {
    overflow: visible;
}

.swiper-container-flip .swiper-slide {
    pointer-events: none;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    z-index: 1;
}

.swiper-container-flip .swiper-slide .swiper-slide {
    pointer-events: none;
}

.swiper-container-flip .swiper-slide-active,
.swiper-container-flip .swiper-slide-active .swiper-slide-active {
    pointer-events: auto;
}

.swiper-container-flip .swiper-slide-shadow-bottom,
.swiper-container-flip .swiper-slide-shadow-left,
.swiper-container-flip .swiper-slide-shadow-right,
.swiper-container-flip .swiper-slide-shadow-top {
    z-index: 0;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
}

.swiper-container-coverflow .swiper-wrapper {
    -ms-perspective: 1200px;
}

.news-wrapper .vueperslide__content-wrapper.blog-img-layer {
    background: white;
}

.reg-container .flex {
    text-align: left;
}

.reg-container .v-input--checkbox .v-input__slot {
    margin-bottom: 0;
}

.reg-container .v-input--selection-controls {
    margin-top: 0;
    padding-top: 0;
}

.reg-container span {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: rgba(0, 0, 0, 0.64);
}

.reg-container .flex .v-text-field {
    padding-top: 0;
    margin-top: 0;
}

.reg-container .v-input input {
    height: 32px;
    max-height: unset;
    margin-top: 0;
    padding-left: 15px;
}

.reg-container .v-text-field .v-input__append-inner {
    margin-top: 0;
    background: #fff;
    height: 32px;
}

.reg-container .v-text-field .v-input__append-inner .v-input__icon {
    margin-top: 5px;
}

.reg-container .v-text-field .v-input__append-inner .primary--text {
    color: #000 !important;
    caret-color: #000 !important;
}

.reg-container .theme--light.v-input:not(.v-input--is-disabled) input {
    border: 0;
}

.reg-container .theme--light.v-text-field:not(.v-input--has-state) > .v-input__control > .v-input__slot:hover:before {
    border-color: var(--brand);
}

.reg-container .theme--light.v-text-field > .v-input__control > .v-input__slot:after {
    border-color: rgba(0, 0, 0, .87);
    border-width: 1px;
}

.reg-container .theme--light.v-text-field.error--text > .v-input__control > .v-input__slot:after {
    border-color: #ff5252;
}

.reg-container .check-terms a {
    text-decoration: none;
    color: #707070;
    font-size: 19px;
    font-weight: 300;
}

.reg-container .v-input__slot {
    margin-bottom: 0;
}

.reg-container .check-terms a:hover {
    color: var(--brand);
}

.reg-container .v-input--checkbox label {
    font-size: 12px;
    line-height: 15px;
}

.reg-container .v-input--checkbox .v-messages {
    display: none;
}

.theme--light.v-btn.v-btn--has-bg.login-submit span {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    color: #FFFFFF;
}

.home-section1-img img {
    background-size: contain;
    width: 100%;
    height: 100%;
    max-height: 360px;
    max-width: 178px;
    margin-top: 23px;
}

@media (min-width: 768px) {
    .news-articles-carousel:not(.vueperslides--slide-multiple) .vueperslide {
        left: -40%;
        opacity: 0.7;
    }
    .news-articles-carousel:not(.vueperslides--slide-multiple) .vueperslide--active {
        left: 0;
        opacity: 1;
    }
}
</style>
